/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  AWSDate: string
  AWSDateTime: string
  AWSJSON: string
  AWSTime: string
}

export type ActionEntry = {
  author: AuditEntry
  code: ActionEntryCode
  description: Scalars['String']
}

export enum ActionEntryCode {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export enum ActiveStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type Address = {
  city: Scalars['String']
  countryCode?: Maybe<Scalars['String']>
  line: Array<Scalars['String']>
  postalCode: Scalars['String']
  state: Scalars['String']
  text?: Maybe<Scalars['String']>
}

export type AddressComponents = {
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
}

export type AddressComponentsInput = {
  city?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  zipcode?: InputMaybe<Scalars['String']>
}

export type AddressCreateInput = {
  city: Scalars['String']
  countryCode?: InputMaybe<Scalars['String']>
  line: Array<Scalars['String']>
  postalCode: Scalars['String']
  state: Scalars['String']
}

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']>
  countryCode?: InputMaybe<Scalars['String']>
  line?: InputMaybe<Array<Scalars['String']>>
  postalCode?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type Annotation = IAnnotation & {
  authorReference: Reference
  text: Scalars['String']
  time: Scalars['AWSDateTime']
}

export type AppendListItemInput = {
  description?: InputMaybe<Scalars['String']>
  label: Scalars['String']
  sortOrder?: InputMaybe<Scalars['Int']>
  value: Scalars['String']
}

export type Appointment = Node & {
  _id: Scalars['ID']
  appointmentType: AppointmentType
  cancelationReason?: Maybe<Scalars['String']>
  createdDate: Scalars['AWSDateTime']
  description?: Maybe<Scalars['String']>
  endDate: Scalars['AWSDateTime']
  fulfilledStatus?: Maybe<FulfilledAppointmentStatistics>
  identifiers?: Maybe<Array<AppointmentIdentifier>>
  minutesDuration?: Maybe<Scalars['Float']>
  notes?: Maybe<Array<Annotation>>
  occuranceChanged?: Maybe<Scalars['Boolean']>
  occuranceIndex?: Maybe<Scalars['Int']>
  participants: Array<Participant>
  reoccuranceTemplate?: Maybe<ReoccuranceTemplate>
  replacesAppointmentId?: Maybe<Scalars['ID']>
  serviceCategory: ServiceCategory
  serviceType?: Maybe<ServiceType>
  startDate: Scalars['AWSDateTime']
  status: AppointmentStatus
  virtualService?: Maybe<VirtualService>
}

export type AppointmentDisplay = {
  careManagerDisplay?: Maybe<Scalars['String']>
  careManagerId?: Maybe<Scalars['ID']>
  endDateTime: Scalars['AWSDateTime']
  startDateTime: Scalars['AWSDateTime']
  type?: Maybe<Scalars['String']>
}

export type AppointmentFlags = {
  disableLegacyAppointmentSideEffects?: Maybe<Scalars['Boolean']>
  useSchedulingAppt?: Maybe<Scalars['Boolean']>
}

export type AppointmentIdentifier = {
  source: AppointmentIdentifierSource
  value?: Maybe<Scalars['String']>
}

export type AppointmentIdentifierInput = {
  source: AppointmentIdentifierSource
  value?: InputMaybe<Scalars['String']>
}

export enum AppointmentIdentifierSource {
  CareManager = 'CARE_MANAGER',
  DrChrono = 'DR_CHRONO',
}

export type AppointmentInput = {
  appointmentType?: InputMaybe<AppointmentType>
  cancelationReason?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['AWSDateTime']>
  fulfilledStatus?: InputMaybe<FulfilledAppointmentStatisticsInput>
  identifiers?: InputMaybe<Array<AppointmentIdentifierInput>>
  minutesDuration?: InputMaybe<Scalars['Float']>
  note?: InputMaybe<Scalars['String']>
  participants?: InputMaybe<Array<ParticipantInput>>
  reoccuranceTemplate?: InputMaybe<ReoccuranceTemplateInput>
  replacesAppointmentId?: InputMaybe<Scalars['String']>
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  startDate?: InputMaybe<Scalars['AWSDateTime']>
  status?: InputMaybe<AppointmentStatus>
  virtualService?: InputMaybe<VirtualServiceInput>
}

export type AppointmentOptions = {
  forceOverlap?: InputMaybe<Scalars['Boolean']>
}

export type AppointmentParticipantType = ICodeableConcept & {
  code: AppointmentParticipantTypeCode
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']>
}

export enum AppointmentParticipantTypeCode {
  CoveringProvider = 'COVERING_PROVIDER',
  Patient = 'PATIENT',
  PrimaryPerformer = 'PRIMARY_PERFORMER',
}

export type AppointmentResponse = {
  results: Array<Appointment>
  searchAfter?: Maybe<Scalars['AWSJSON']>
  totalCount: Scalars['Int']
}

export type AppointmentSettings = {
  flags?: Maybe<AppointmentFlags>
}

export enum AppointmentStatus {
  Booked = 'BOOKED',
  Canceled = 'CANCELED',
  Canceled_24 = 'CANCELED_24',
  Canceled_48 = 'CANCELED_48',
  EnteredInError = 'ENTERED_IN_ERROR',
  Fulfilled = 'FULFILLED',
  Noshow = 'NOSHOW',
  Pending = 'PENDING',
  Proposed = 'PROPOSED',
  Rescheduled = 'RESCHEDULED',
  Waitlist = 'WAITLIST',
}

export enum AppointmentType {
  Checkup = 'CHECKUP',
  Emergency = 'EMERGENCY',
  Followup = 'FOLLOWUP',
  Routine = 'ROUTINE',
}

export type AppointmentWarning = {
  code?: Maybe<AppointmentWarningCode>
  endDate: Scalars['AWSDateTime']
  id: Scalars['ID']
  message?: Maybe<Scalars['String']>
  startDate: Scalars['AWSDateTime']
}

export enum AppointmentWarningCode {
  AppointmentOverlap = '[appointment_overlap]',
}

export type AttachmentAnnotation = IAnnotation & {
  attachments?: Maybe<Array<File>>
  authorReference: Reference
  text: Scalars['String']
  time: Scalars['AWSDateTime']
}

export type AttachmentAnnotationInput = {
  attachments?: InputMaybe<Array<FileCreate>>
  text: Scalars['String']
}

export type AuditEntry = {
  date: Scalars['AWSDateTime']
  reference: Reference
}

export enum Availability {
  CareCoordinatorOnly = 'CARE_COORDINATOR_ONLY',
  Closed = 'CLOSED',
  Open = 'OPEN',
  OpenFlexible = 'OPEN_FLEXIBLE',
  OpenPrioritized = 'OPEN_PRIORITIZED',
  Pending = 'PENDING',
  PilotOnly = 'PILOT_ONLY',
  Recruiting = 'RECRUITING',
  WaitlistOnly = 'WAITLIST_ONLY',
}

export type BillingInsured = {
  addressComponents?: Maybe<AddressComponents>
  cardBack?: Maybe<File>
  cardFront?: Maybe<File>
  coPay?: Maybe<Scalars['String']>
  coinsurance?: Maybe<Scalars['Int']>
  dateOfBirth?: Maybe<Scalars['AWSDate']>
  deductible?: Maybe<Scalars['Int']>
  effectiveDate?: Maybe<Scalars['AWSDate']>
  eligibilityReason?: Maybe<Scalars['String']>
  eligibilityVerification?: Maybe<EligibilityVerification>
  eligibilityVerified?: Maybe<Scalars['Boolean']>
  emrSyncStatus?: Maybe<EmrSyncStatusCode>
  expirationDate?: Maybe<Scalars['AWSDate']>
  familyDeductible?: Maybe<Scalars['Int']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  idNumber?: Maybe<Scalars['String']>
  insurancePlanId?: Maybe<Scalars['ID']>
  lastName?: Maybe<Scalars['String']>
  legalSex?: Maybe<PatientLegalSex>
  medicaidCard?: Maybe<File>
  medicaidIdNumber?: Maybe<Scalars['String']>
  medicareCard?: Maybe<File>
  medicareIdNumber?: Maybe<Scalars['String']>
  middleInitial?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  outOfNetwork?: Maybe<Scalars['Boolean']>
  outOfNetworkPlan?: Maybe<OutOfNetworkPlan>
  payerPlanName?: Maybe<Scalars['String']>
  payerPlanType?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  policyGroupFecaNumber?: Maybe<Scalars['String']>
  policyGroupName?: Maybe<Scalars['String']>
  priorAuthRequired?: Maybe<PriorAuthStatus>
  relationship?: Maybe<PatientRelationshipToInsured>
  type?: Maybe<InsuranceOrdinality>
}

export type BillingInsuredInput = {
  addressComponents?: InputMaybe<AddressComponentsInput>
  cardBack?: InputMaybe<FileUpdate>
  cardFront?: InputMaybe<FileUpdate>
  coPay?: InputMaybe<Scalars['String']>
  coinsurance?: InputMaybe<Scalars['Int']>
  dateOfBirth?: InputMaybe<Scalars['AWSDate']>
  deductible?: InputMaybe<Scalars['Int']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  eligibilityVerified?: InputMaybe<Scalars['Boolean']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  familyDeductible?: InputMaybe<Scalars['Int']>
  firstName?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['String']>
  idNumber?: InputMaybe<Scalars['String']>
  insurancePlanId?: InputMaybe<Scalars['ID']>
  lastName?: InputMaybe<Scalars['String']>
  legalSex?: InputMaybe<PatientLegalSex>
  medicaidCard?: InputMaybe<FileUpdate>
  medicaidIdNumber?: InputMaybe<Scalars['String']>
  medicareCard?: InputMaybe<FileUpdate>
  medicareIdNumber?: InputMaybe<Scalars['String']>
  middleInitial?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  outOfNetwork?: InputMaybe<Scalars['Boolean']>
  outOfNetworkPlan?: InputMaybe<OutOfNetworkPlanInput>
  payerPlanName?: InputMaybe<Scalars['String']>
  payerPlanType?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  policyGroupFecaNumber?: InputMaybe<Scalars['String']>
  policyGroupName?: InputMaybe<Scalars['String']>
  priorAuthRequired?: InputMaybe<PriorAuthStatus>
  relationship?: InputMaybe<PatientRelationshipToInsured>
  type?: InputMaybe<InsuranceOrdinality>
}

export enum BillingRelationshipType {
  Autoinherited = 'AUTOINHERITED',
  Direct = 'DIRECT',
  Inherited = 'INHERITED',
}

export type BulkInsurancePlanUpdateInput = {
  _id: Scalars['ID']
  billingPayerName?: InputMaybe<Scalars['String']>
  comment?: InputMaybe<Scalars['String']>
  credentialingPayerId?: InputMaybe<Scalars['String']>
  credentialingPayerName?: InputMaybe<Scalars['String']>
  delegatedAuditDate?: InputMaybe<Scalars['AWSDate']>
  delegatedEffectiveDate?: InputMaybe<Scalars['AWSDate']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  groupId?: InputMaybe<Scalars['String']>
  inNetworkBenefitTerms?: InputMaybe<Scalars['String']>
  isDelegated?: InputMaybe<Scalars['Boolean']>
  isInNetwork?: InputMaybe<Scalars['Boolean']>
  isInheritanceDisabled?: InputMaybe<Scalars['Boolean']>
  lineOfBusiness?: InputMaybe<InsurancePlanLineOfBusiness>
  notes?: InputMaybe<Scalars['String']>
  outOfNetworkBenefitTerms?: InputMaybe<Scalars['String']>
  payerCode?: InputMaybe<Scalars['String']>
  payerId?: InputMaybe<Scalars['String']>
  planId?: InputMaybe<Scalars['String']>
  planType?: InputMaybe<Scalars['String']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']>
  status?: InputMaybe<InsurancePlanStatus>
  vendorName?: InputMaybe<Scalars['String']>
  verificationDefaultLocation?: InputMaybe<Scalars['String']>
  verificationDefaultProviderName?: InputMaybe<Scalars['String']>
  verificationDefaultProviderNpi?: InputMaybe<Scalars['String']>
  verificationPayerId?: InputMaybe<Scalars['String']>
  verificationPayerName?: InputMaybe<Scalars['String']>
}

export type CareManagerPermissions = {
  accessToNotes?: Maybe<Scalars['Boolean']>
  addPatients?: Maybe<Scalars['Boolean']>
  caseloadBulkSend?: Maybe<Scalars['Boolean']>
  isAdmin?: Maybe<Scalars['Boolean']>
  isSupervisor?: Maybe<Scalars['Boolean']>
  providerListRead?: Maybe<Scalars['Boolean']>
  providerListWrite?: Maybe<Scalars['Boolean']>
  viewAllPatients?: Maybe<Scalars['Boolean']>
}

export type CareManagerPermissionsInput = {
  accessToNotes?: InputMaybe<Scalars['Boolean']>
  addPatients?: InputMaybe<Scalars['Boolean']>
  caseloadBulkSend?: InputMaybe<Scalars['Boolean']>
  isAdmin?: InputMaybe<Scalars['Boolean']>
  isSupervisor?: InputMaybe<Scalars['Boolean']>
  providerListRead?: InputMaybe<Scalars['Boolean']>
  providerListWrite?: InputMaybe<Scalars['Boolean']>
  viewAllPatients?: InputMaybe<Scalars['Boolean']>
}

export type CareManagerUser = {
  careManagerId: Scalars['String']
  email: Scalars['String']
  emrId?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  id: Scalars['String']
  isEnabled: Scalars['Boolean']
  isProvider: Scalars['Boolean']
  lastName: Scalars['String']
  permissions?: Maybe<CareManagerPermissions>
  pronouns?: Maybe<Scalars['String']>
  username: Scalars['String']
}

/** This is named different than the api and thus cannot use fragments */
export type CareTeamSearchMember = {
  careManagerId: Scalars['ID']
  display?: Maybe<Scalars['String']>
  isPrimary: Scalars['Boolean']
}

export type CodeableConcept = ICodeableConcept & {
  code?: Maybe<Scalars['String']>
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']>
}

export type Coding = {
  code: Scalars['String']
  display?: Maybe<Scalars['String']>
  system?: Maybe<Scalars['String']>
}

export type Cognito = {
  isEnabled: Scalars['Boolean']
  userAttributes: CognitoAttributes
  userStatus: Scalars['String']
  username: Scalars['String']
}

export type CognitoAttributes = {
  email: Scalars['String']
  email_verified?: Maybe<Scalars['Boolean']>
  family_name?: Maybe<Scalars['String']>
  given_name?: Maybe<Scalars['String']>
  identities?: Maybe<Scalars['String']>
  middle_name?: Maybe<Scalars['String']>
  nickname?: Maybe<Scalars['String']>
  phone_number?: Maybe<Scalars['String']>
  phone_number_verified?: Maybe<Scalars['Boolean']>
  picture?: Maybe<Scalars['String']>
  preferred_username?: Maybe<Scalars['String']>
  pronouns?: Maybe<Scalars['String']>
  sub: Scalars['String']
  updated_at?: Maybe<Scalars['String']>
}

export enum CognitoUserStatus {
  Archived = 'ARCHIVED',
  Compromised = 'COMPROMISED',
  Confirmed = 'CONFIRMED',
  ExternalProvider = 'EXTERNAL_PROVIDER',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN',
}

export type CommentAnnotationInput = {
  text: Scalars['String']
}

export enum CommunicationMedium {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export enum CommunityIdentity {
  Bipoc = 'BIPOC',
  Lgbtqia = 'LGBTQIA',
}

export type CompletePatientRegistrationSubmission = {
  submissionId: Scalars['String']
}

export type ConfigItem = {
  key: Scalars['String']
  value: Scalars['AWSJSON']
}

export type ConfirmOtpAndMatchInput = {
  dateOfBirth: Scalars['AWSDate']
  firstName: Scalars['String']
  lastName: Scalars['String']
  otpToken: Scalars['String']
  phoneNumber: Scalars['String']
  publicCode?: InputMaybe<Scalars['String']>
}

export type ConfirmOtpResponse = {
  access_token: Scalars['String']
  expires_in: Scalars['Int']
  token_type: TokenType
}

export type ConsentPacketInfo = {
  agreementId?: Maybe<Scalars['ID']>
  sent?: Maybe<AuditEntry>
  signedDate?: Maybe<Scalars['AWSDateTime']>
}

export type Contact = {
  email?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  phone: Scalars['String']
  primary?: InputMaybe<Scalars['Boolean']>
  relation: PatientContactRelation
  use?: InputMaybe<PatientContactUse>
}

export type CreateAppointmentResponse = {
  appointment: Appointment
  warnings: Array<AppointmentWarning>
}

export type CreateDocumentInput = {
  file: FileCreate
}

export type CreatePatientBillingInput = {
  data: UpdateBillingInput
  treatmentId: Scalars['ID']
}

export type CreatePatientRegistrationSubmission = {
  additionalTaskDescription?: InputMaybe<Scalars['AWSJSON']>
  address?: InputMaybe<AddressComponentsInput>
  billing?: InputMaybe<UpdateBillingInput>
  conditionInterferingWithVirtualTreatment?: InputMaybe<Scalars['Boolean']>
  contacts?: InputMaybe<Array<Contact>>
  dischargeDate?: InputMaybe<Scalars['AWSDate']>
  dischargeType?: InputMaybe<Scalars['String']>
  dob: Scalars['AWSDate']
  documents?: InputMaybe<Array<CreateDocumentInput>>
  email: Scalars['String']
  firstName: Scalars['String']
  gender?: InputMaybe<PatientGenderIdentity>
  genderDetails?: InputMaybe<Scalars['String']>
  hospitalized?: InputMaybe<Scalars['Boolean']>
  lastName: Scalars['String']
  legalSex: PatientLegalSex
  meta?: InputMaybe<Scalars['AWSJSON']>
  patientTimeZone?: InputMaybe<Scalars['String']>
  phoneNumber: Scalars['String']
  preferredContactDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  preferredContactTimes?: InputMaybe<Array<Scalars['String']>>
  preferredLanguage?: InputMaybe<Scalars['String']>
  preferredName?: InputMaybe<Scalars['String']>
  referralSource?: InputMaybe<Scalars['String']>
  referralSourceOther?: InputMaybe<Scalars['String']>
  referrer?: InputMaybe<ReferrerInformation>
  serviceType?: InputMaybe<Array<Scalars['String']>>
  specialty?: InputMaybe<Array<Scalars['String']>>
  taskTypeOverride?: InputMaybe<PatientOnboardingTaskType>
  tellUsMore?: InputMaybe<Scalars['String']>
  treatmentHistory?: InputMaybe<Scalars['String']>
}

export type CreatePayerEnrollmentInput = {
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  entity?: InputMaybe<Scalars['String']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  payerExternalProviderId?: InputMaybe<Scalars['String']>
  payerId: Scalars['ID']
  recredentialingDate?: InputMaybe<Scalars['AWSDate']>
  status: Scalars['String']
  submissionDate?: InputMaybe<Scalars['AWSDate']>
  terminationDate?: InputMaybe<Scalars['AWSDate']>
  vendor?: InputMaybe<Scalars['String']>
}

export type CreateProviderDocumentInput = {
  documentCategory: DocumentCategory
  file: FileCreate
  stateCode?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DocumentVerificationStatus>
}

export type CreateTaskInput = {
  assignee: Scalars['ID']
  comment?: InputMaybe<Scalars['String']>
  description: Scalars['String']
  dueDate: Scalars['AWSDate']
  patient?: InputMaybe<PatientMetaDataInput>
  patientId: Scalars['ID']
  patientPreferences?: InputMaybe<Scalars['AWSJSON']>
  referralSource?: InputMaybe<Scalars['String']>
  serviceType?: InputMaybe<TaskServiceType>
  status: TaskStatus
  treatmentId: Scalars['ID']
  type: TaskType
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type DayTime = {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']
  startTime: Scalars['AWSTime']
}

export type DayTimeInput = {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']
  startTime: Scalars['AWSTime']
}

export type DecryptInput = {
  algorithm?: InputMaybe<Scalars['String']>
  cipherText: Scalars['String']
  entityId: Scalars['ID']
  fieldReference: FieldReference
}

export type DecryptResponse = {
  plainText: Scalars['String']
}

export type Document = {
  created: AuditEntry
  file: File
  id: Scalars['ID']
  modified?: Maybe<AuditEntry>
}

export enum DocumentCategory {
  Attestation = 'ATTESTATION',
  ClinicalAcknowledgement = 'CLINICAL_ACKNOWLEDGEMENT',
  ClinicalLicense = 'CLINICAL_LICENSE',
  ClinicalRegistration = 'CLINICAL_REGISTRATION',
  Cme = 'CME',
  DeaLicense = 'DEA_LICENSE',
  Education = 'EDUCATION',
  Id = 'ID',
  Other = 'OTHER',
  PrimaryLiabilityInsurance = 'PRIMARY_LIABILITY_INSURANCE',
  ProfessionalLiabilityInsurance = 'PROFESSIONAL_LIABILITY_INSURANCE',
  Report = 'REPORT',
  ReportsAndVerifications = 'REPORTS_AND_VERIFICATIONS',
  /** Deprecated */
  ReportCaqhSummary = 'REPORT_CAQH_SUMMARY',
  /** Deprecated */
  ReportCmsOptOut = 'REPORT_CMS_OPT_OUT',
  /** Deprecated */
  ReportNpdbQuery = 'REPORT_NPDB_QUERY',
  /** Deprecated */
  ReportNppesOrNpi = 'REPORT_NPPES_OR_NPI',
  /** Deprecated */
  ReportOfac = 'REPORT_OFAC',
  /** Deprecated */
  ReportOig = 'REPORT_OIG',
  /** Deprecated */
  ReportSam = 'REPORT_SAM',
  /** Deprecated */
  ReportSsnvsFile = 'REPORT_SSNVS_FILE',
  Specialty = 'SPECIALTY',
}

export enum DocumentVerificationStatus {
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED',
}

export enum EducationProgramType {
  Associates = 'ASSOCIATES',
  ElementaryPrimarySchool = 'ELEMENTARY_PRIMARY_SCHOOL',
  GraduateSchool = 'GRADUATE_SCHOOL',
  HighSchool = 'HIGH_SCHOOL',
  LawSchool = 'LAW_SCHOOL',
  Masters = 'MASTERS',
  MedicalSchool = 'MEDICAL_SCHOOL',
  NursingGraduateProgram = 'NURSING_GRADUATE_PROGRAM',
  Undergraduate = 'UNDERGRADUATE',
}

export type EligibilityInsured = {
  dateOfServiceEnd: Scalars['String']
  dateOfServiceStart: Scalars['String']
  dob: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  memberId: Scalars['String']
  patientRelationship: Scalars['String']
}

export type EligibilityInsuredInput = {
  dateOfServiceStart: Scalars['String']
  dob: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  memberId: Scalars['String']
  patientRelationship: PatientRelationshipToInsured
}

export type EligibilityPatient = {
  dob: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  mrn?: Maybe<Scalars['String']>
}

export type EligibilityPatientInput = {
  dob: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  mrn?: InputMaybe<Scalars['String']>
}

export type EligibilityVerification = {
  actionLog: Array<ActionEntry>
  benefitSummaryPdfFile?: Maybe<Scalars['String']>
  billingInsuranceId?: Maybe<Scalars['ID']>
  generatingBenefitSummaryPdfFile?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  insurancePlanId?: Maybe<Scalars['ID']>
  insured?: Maybe<EligibilityInsured>
  isActive?: Maybe<Scalars['Boolean']>
  location: Scalars['String']
  payerId: Scalars['String']
  providerName: Scalars['String']
  providerNpi: Scalars['String']
  requestId?: Maybe<Scalars['Int']>
  treatmentId?: Maybe<Scalars['ID']>
  ts?: Maybe<Scalars['AWSDateTime']>
  vendor?: Maybe<VerificationVendor>
}

export type Employment = {
  _id: Scalars['ID']
  hireDate?: Maybe<Scalars['AWSDate']>
  legalSex?: Maybe<LegalSex>
  profession?: Maybe<ProfessionCode>
  role?: Maybe<EmploymentRole>
  startDate?: Maybe<Scalars['AWSDate']>
  stateOfResidence?: Maybe<Scalars['String']>
  status?: Maybe<EmploymentStatus>
  terminationDate?: Maybe<Scalars['AWSDate']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<EmploymentType>
}

export type EmploymentInput = {
  hireDate?: InputMaybe<Scalars['AWSDate']>
  legalSex?: InputMaybe<LegalSex>
  profession?: InputMaybe<ProfessionCode>
  role?: InputMaybe<EmploymentRole>
  startDate?: InputMaybe<Scalars['AWSDate']>
  stateOfResidence?: InputMaybe<Scalars['String']>
  status?: InputMaybe<EmploymentStatus>
  terminationDate?: InputMaybe<Scalars['AWSDate']>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<EmploymentType>
}

export enum EmploymentRole {
  AssociateTherapist = 'ASSOCIATE_THERAPIST',
  CareCoordinator = 'CARE_COORDINATOR',
  CaseManager = 'CASE_MANAGER',
  GroupTherapy = 'GROUP_THERAPY',
  HealthConnector = 'HEALTH_CONNECTOR',
  MedicalAssistant = 'MEDICAL_ASSISTANT',
  Prescriber = 'PRESCRIBER',
  PrescriberSupervisor = 'PRESCRIBER_SUPERVISOR',
  Therapist = 'THERAPIST',
  TherapistSupervisor = 'THERAPIST_SUPERVISOR',
}

export enum EmploymentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Onleave = 'ONLEAVE',
  Pending = 'PENDING',
  Resigning = 'RESIGNING',
}

export enum EmploymentType {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
}

export type EmrSyncStatistics = {
  emrSyncStatus: EmrSyncStatusCode
  lastSynced?: Maybe<AuditEntry>
}

export enum EmrSyncStatusCode {
  Error = 'ERROR',
  ImportantUnsynced = 'IMPORTANT_UNSYNCED',
  InProgress = 'IN_PROGRESS',
  PartialUnsynced = 'PARTIAL_UNSYNCED',
  Synced = 'SYNCED',
  Unknown = 'UNKNOWN',
}

export type EncryptInput = {
  entityId: Scalars['ID']
  fieldReference: FieldReference
  plainText: Scalars['String']
}

export type EncryptResponse = {
  algorithm: Scalars['String']
  cipherText: Scalars['String']
}

export type EncryptedValue = {
  algorithm: Scalars['String']
  cipherText: Scalars['String']
  display?: Maybe<Scalars['String']>
}

export enum Ethnicity {
  Hispanic = 'HISPANIC',
  NotHispanic = 'NOT_HISPANIC',
}

export type ExpectedHours = {
  endDate?: Maybe<Scalars['AWSDate']>
  serviceCategory: ServiceCategory
  startDate?: Maybe<Scalars['AWSDate']>
  weeklyMinutesTotal: Scalars['Int']
}

export type ExpectedHoursInput = {
  endDate?: InputMaybe<Scalars['AWSDate']>
  serviceCategory: ServiceCategoryCode
  startDate?: InputMaybe<Scalars['AWSDate']>
  weeklyMinutesTotal: Scalars['Int']
}

export type ExternalResponse = {
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export enum FieldReference {
  Externalaccountpassword = 'EXTERNALACCOUNTPASSWORD',
  Ssn = 'SSN',
}

export type File = {
  mimeType: Scalars['String']
  name: Scalars['String']
  url: Scalars['String']
}

export type FileCreate = {
  mimeType: Scalars['String']
  name: Scalars['String']
  s3Key: Scalars['String']
}

export type FileUpdate = {
  mimeType?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  s3Key?: InputMaybe<Scalars['String']>
}

export enum GenderIdentity {
  Female = 'FEMALE',
  Genderqueer = 'GENDERQUEER',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  NonDisclose = 'NON_DISCLOSE',
  Other = 'OTHER',
  TransFemale = 'TRANS_FEMALE',
  TransMale = 'TRANS_MALE',
}

export type GeneratePatientLinkInput = {
  treatmentId: Scalars['ID']
}

export type GetExternalPracticeStatesInput = {
  programCode?: InputMaybe<Scalars['String']>
}

export type GetUserByIdInput = {
  careManagerId?: InputMaybe<Scalars['ID']>
  cognitoUserId?: InputMaybe<Scalars['ID']>
}

export type GoogleSignUpInput = {
  careManagerPermissions?: InputMaybe<CareManagerPermissionsInput>
  email: Scalars['String']
  isProvider?: InputMaybe<Scalars['Boolean']>
  permitRoles: Array<Scalars['ID']>
}

export type IAnnotation = {
  authorReference: Reference
  text: Scalars['String']
  time: Scalars['AWSDateTime']
}

export type ICodeableConcept = {
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']>
}

export type IListItem = {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  label: Scalars['String']
  sortOrder?: Maybe<Scalars['Int']>
  value: Scalars['String']
}

export enum IdentificationType {
  DriversLicense = 'drivers_license',
  Passport = 'passport',
  StateId = 'state_id',
}

export type Identifier = {
  period?: Maybe<Period>
  type: CodeableConcept
  value: Scalars['String']
}

export enum InsuranceOrdinality {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export type InsurancePlanBillingRelationship = {
  reference?: Maybe<Reference>
  type: BillingRelationshipType
}

export type InsurancePlanBillingRelationshipInput = {
  referenceId?: InputMaybe<Scalars['ID']>
  type: BillingRelationshipType
}

export type InsurancePlanCreateInput = {
  billingPayerName?: InputMaybe<Scalars['String']>
  comment?: InputMaybe<Scalars['String']>
  credentialingPayerId?: InputMaybe<Scalars['String']>
  credentialingPayerName?: InputMaybe<Scalars['String']>
  delegatedAuditDate?: InputMaybe<Scalars['AWSDate']>
  delegatedEffectiveDate?: InputMaybe<Scalars['AWSDate']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  groupId?: InputMaybe<Scalars['String']>
  inNetworkBenefitTerms?: InputMaybe<Scalars['String']>
  isDelegated: Scalars['Boolean']
  isInNetwork: Scalars['Boolean']
  isInheritanceDisabled?: InputMaybe<Scalars['Boolean']>
  lineOfBusiness?: InputMaybe<InsurancePlanLineOfBusiness>
  name: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  outOfNetworkBenefitTerms?: InputMaybe<Scalars['String']>
  payerCode?: InputMaybe<Scalars['String']>
  payerId?: InputMaybe<Scalars['String']>
  planId?: InputMaybe<Scalars['String']>
  planType?: InputMaybe<Scalars['String']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']>
  stateCode?: InputMaybe<Scalars['String']>
  stateName?: InputMaybe<Scalars['String']>
  status: InsurancePlanStatus
  tocConfiguration?: InputMaybe<Array<TocConfigurationInput>>
  vendorName?: InputMaybe<Scalars['String']>
  verificationDefaultLocation?: InputMaybe<Scalars['String']>
  verificationDefaultProviderName?: InputMaybe<Scalars['String']>
  verificationDefaultProviderNpi?: InputMaybe<Scalars['String']>
  verificationPayerId?: InputMaybe<Scalars['String']>
  verificationPayerName?: InputMaybe<Scalars['String']>
}

export type InsurancePlanExternal = {
  _id: Scalars['ID']
  name: Scalars['String']
  payerId?: Maybe<Scalars['String']>
  payerName?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  stateName?: Maybe<Scalars['String']>
  tocConfiguration?: Maybe<Array<TocConfiguration>>
  verificationPayerId?: Maybe<Scalars['String']>
  verificationPayerName?: Maybe<Scalars['String']>
}

export type InsurancePlanFull = {
  _id: Scalars['ID']
  billingPayerName?: Maybe<Scalars['String']>
  comments?: Maybe<Array<Annotation>>
  credentialingPayerId?: Maybe<Scalars['String']>
  credentialingPayerName?: Maybe<Scalars['String']>
  delegatedAuditDate?: Maybe<Scalars['AWSDate']>
  delegatedEffectiveDate?: Maybe<Scalars['AWSDate']>
  effectiveDate?: Maybe<Scalars['AWSDate']>
  entityName?: Maybe<Scalars['String']>
  expirationDate?: Maybe<Scalars['AWSDate']>
  groupId?: Maybe<Scalars['String']>
  groupNpi?: Maybe<Scalars['String']>
  inNetworkBenefitTerms?: Maybe<Scalars['String']>
  isDelegated: Scalars['Boolean']
  isInNetwork: Scalars['Boolean']
  isInheritanceDisabled?: Maybe<Scalars['Boolean']>
  lineOfBusiness?: Maybe<InsurancePlanLineOfBusiness>
  name: Scalars['String']
  notes?: Maybe<Scalars['String']>
  outOfNetworkBenefitTerms?: Maybe<Scalars['String']>
  payerCode?: Maybe<Scalars['String']>
  payerId?: Maybe<Scalars['String']>
  payerName?: Maybe<Scalars['String']>
  planId?: Maybe<Scalars['String']>
  planType?: Maybe<Scalars['String']>
  recredentialingDate?: Maybe<Scalars['AWSDate']>
  stateCode?: Maybe<Scalars['String']>
  stateName?: Maybe<Scalars['String']>
  status: InsurancePlanStatus
  taxId?: Maybe<Scalars['String']>
  tocConfiguration?: Maybe<Array<TocConfiguration>>
  vendorName?: Maybe<Scalars['String']>
  verificationDefaultLocation?: Maybe<Scalars['String']>
  verificationDefaultProviderName?: Maybe<Scalars['String']>
  verificationDefaultProviderNpi?: Maybe<Scalars['String']>
  verificationPayerId?: Maybe<Scalars['String']>
  verificationPayerName?: Maybe<Scalars['String']>
}

export enum InsurancePlanLineOfBusiness {
  Autoinsurance = 'AUTOINSURANCE',
  Commercial = 'COMMERCIAL',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  Veteransaffairs = 'VETERANSAFFAIRS',
  Workerscomp = 'WORKERSCOMP',
}

export type InsurancePlanPartial = {
  _id: Scalars['ID']
  isInheritanceDisabled?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  payerCode?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  stateName?: Maybe<Scalars['String']>
  status?: Maybe<InsurancePlanStatus>
}

export type InsurancePlanParticipant = {
  _id: Scalars['ID']
  billingRelationship: InsurancePlanBillingRelationship
  comments?: Maybe<Array<AttachmentAnnotation>>
  effectiveDate?: Maybe<Scalars['AWSDate']>
  insurancePlan: InsurancePlanPartial
  status?: Maybe<InsurancePlanParticipantStatus>
  terminationDate?: Maybe<Scalars['AWSDate']>
}

export type InsurancePlanParticipantInput = {
  _id?: InputMaybe<Scalars['ID']>
  billingRelationship: InsurancePlanBillingRelationshipInput
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  identifier?: InputMaybe<Scalars['String']>
  insurancePlanId: Scalars['ID']
  status?: InputMaybe<InsurancePlanParticipantStatus>
  terminationDate?: InputMaybe<Scalars['AWSDate']>
}

export enum InsurancePlanParticipantStatus {
  Active = 'ACTIVE',
  ExistingPatientOnly = 'EXISTING_PATIENT_ONLY',
  Inactive = 'INACTIVE',
}

export enum InsurancePlanStatus {
  Active = 'ACTIVE',
  Contractinprogress = 'CONTRACTINPROGRESS',
  Groupinprogress = 'GROUPINPROGRESS',
  Inactive = 'INACTIVE',
  Onhold = 'ONHOLD',
}

export type InsurancePlanUpdateInput = {
  billingPayerName?: InputMaybe<Scalars['String']>
  comment?: InputMaybe<Scalars['String']>
  credentialingPayerId?: InputMaybe<Scalars['String']>
  credentialingPayerName?: InputMaybe<Scalars['String']>
  delegatedAuditDate?: InputMaybe<Scalars['AWSDate']>
  delegatedEffectiveDate?: InputMaybe<Scalars['AWSDate']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  groupId?: InputMaybe<Scalars['String']>
  inNetworkBenefitTerms?: InputMaybe<Scalars['String']>
  isDelegated?: InputMaybe<Scalars['Boolean']>
  isInNetwork?: InputMaybe<Scalars['Boolean']>
  isInheritanceDisabled?: InputMaybe<Scalars['Boolean']>
  lineOfBusiness?: InputMaybe<InsurancePlanLineOfBusiness>
  name?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  outOfNetworkBenefitTerms?: InputMaybe<Scalars['String']>
  payerCode?: InputMaybe<Scalars['String']>
  payerId?: InputMaybe<Scalars['String']>
  payerName?: InputMaybe<Scalars['String']>
  planType?: InputMaybe<Scalars['String']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']>
  stateCode?: InputMaybe<Scalars['String']>
  stateName?: InputMaybe<Scalars['String']>
  status?: InputMaybe<InsurancePlanStatus>
  tocConfiguration?: InputMaybe<Array<TocConfigurationInput>>
  vendorName?: InputMaybe<Scalars['String']>
  verificationDefaultLocation?: InputMaybe<Scalars['String']>
  verificationDefaultProviderName?: InputMaybe<Scalars['String']>
  verificationDefaultProviderNpi?: InputMaybe<Scalars['String']>
  verificationPayerId?: InputMaybe<Scalars['String']>
  verificationPayerName?: InputMaybe<Scalars['String']>
}

export type InternationalAddress = {
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  line?: Maybe<Array<Maybe<Scalars['String']>>>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
}

export type InternationalAddressInput = {
  city?: InputMaybe<Scalars['String']>
  countryCode?: InputMaybe<Scalars['String']>
  line?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  postalCode?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
}

export type Language = {
  code?: Maybe<Scalars['String']>
  display: Scalars['String']
}

export enum LegalSex {
  Female = 'FEMALE',
  Male = 'MALE',
}

export enum LicenseDurationType {
  AutonomousRegistration = 'AUTONOMOUS_REGISTRATION',
  Limited = 'LIMITED',
  Multistate = 'MULTISTATE',
  Permanent = 'PERMANENT',
  PrescriptionAuthority = 'PRESCRIPTION_AUTHORITY',
  Telemedicine = 'TELEMEDICINE',
  Temporary = 'TEMPORARY',
  Training = 'TRAINING',
}

export enum LicenseRequestStatus {
  Completed = 'COMPLETED',
  NotSubmitted = 'NOT_SUBMITTED',
  Pending = 'PENDING',
  PendingProvider = 'PENDING_PROVIDER',
  PsvInProgress = 'PSV_IN_PROGRESS',
  PsvSubmitted = 'PSV_SUBMITTED',
}

export enum LicenseRequestType {
  Loq = 'LOQ',
  New = 'NEW',
  Reinstatement = 'REINSTATEMENT',
  Renewal = 'RENEWAL',
}

export enum LicenseType {
  Counselor = 'COUNSELOR',
  Csr = 'CSR',
  Dea = 'DEA',
  Do = 'DO',
  Lcadc = 'LCADC',
  Lcpc = 'LCPC',
  Lcsw = 'LCSW',
  Lcswa = 'LCSWA',
  Licsw = 'LICSW',
  Lisw = 'LISW',
  Lmft = 'LMFT',
  Lmhc = 'LMHC',
  Lmsw = 'LMSW',
  Lpc = 'LPC',
  Lpn = 'LPN',
  Lsw = 'LSW',
  Md = 'MD',
  MhcLp = 'MHC-LP',
  MsMt = 'MS-MT',
  Np = 'NP',
  Pmhnp = 'PMHNP',
  PhD = 'PhD',
  Rn = 'RN',
}

export type ListEligibilityVerificationInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']>
  billingInsuranceType?: InputMaybe<Scalars['String']>
  from?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  treatmentId: Scalars['ID']
}

export type ListPatientEligibilityVerificationInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']>
  billingInsuranceType?: InputMaybe<Scalars['String']>
  from?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type ListResponse = {
  key: Scalars['String']
  list?: Maybe<Array<IListItem>>
}

export type LoadEligibilityVerificationInput = {
  billingInsuranceId: Scalars['String']
  treatmentId: Scalars['String']
}

export type LoadPatientBillingInput = {
  id?: InputMaybe<Scalars['ID']>
  treatmentId?: InputMaybe<Scalars['ID']>
}

export type Location = {
  address: Address
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  identifiers?: Maybe<Array<Identifier>>
  name: Scalars['String']
  physicalType: CodeableConcept
}

export type LocationSummary = {
  id: Scalars['ID']
  name: Scalars['String']
  stateCode?: Maybe<Scalars['String']>
}

export type MatchedTokenResponse = {
  access_token: Scalars['String']
  expires_in: Scalars['Int']
  id_token: Scalars['String']
  token_type: TokenType
}

export type MonthlyTemplate = PatternTemplate & {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']
  interval: Scalars['Int']
  nthWeekOfMonth: WeekOfMonth
  offset: Scalars['Int']
  startTime: Scalars['AWSTime']
}

export type MonthlyTemplateInput = {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']
  interval: Scalars['Int']
  nthWeekOfMonth: WeekOfMonth
  offset: Scalars['Int']
  startTime: Scalars['AWSTime']
}

export type Mutation = {
  addProviderLicenseRequests: Array<ProviderLicenseRequest>
  appendDocuments: Array<Document>
  appendInsurancePlanParticipants: Array<InsurancePlanParticipant>
  appendListItems: Array<IListItem>
  appendProviderDocuments: Array<ProviderDocument>
  appendProviderLicenses: Array<ProviderLicense>
  appendVerifiedProviderDocuments: Array<ProviderDocument>
  bulkUpdateInsurancePlans: Array<InsurancePlanFull>
  completePatientRegistrationSubmission: SubmissionResponse
  confirmOTPAndMatch?: Maybe<MatchedTokenResponse>
  createAppointment: Appointment
  createAppointmentV2: CreateAppointmentResponse
  createInsurancePlan: InsurancePlanFull
  createPatientRegistrationSubmission: SubmissionResponse
  createPayerEnrollments: Array<PayerEnrollment>
  createPayers: Array<Payer>
  createProfessionalHistory: Array<ProfessionalHistory>
  createProvider: Provider
  createSchedule: Schedule
  createTask: Task
  decrypt: DecryptResponse
  deleteAppointment: Appointment
  deleteIdentifiers: Array<ProviderIdentifier>
  deleteInsurancePlan: InsurancePlanFull
  deleteListItems: Array<IListItem>
  deletePayerEnrollments: Array<PayerEnrollment>
  deletePayers: Array<Payer>
  deleteProfessionalHistory: Array<ProfessionalHistory>
  deleteProvider: Provider
  deleteProviderExternalAccounts: Array<ProviderExternalAccount>
  deleteSchedule: Schedule
  deleteTask: Task
  encrypt: EncryptResponse
  generatePatientLink: PatientLink
  patchSetting: ConfigItem
  removeDocuments: Array<Document>
  removeInsurancePlanParticipants: Array<InsurancePlanParticipant>
  removeProviderDocuments: Array<ProviderDocument>
  removeProviderLicenseRequests: Array<ProviderLicenseRequest>
  removeProviderLicenses: Array<ProviderLicense>
  removeUser: User
  removeVerifiedProviderDocuments: Array<ProviderDocument>
  resendUserPassword: ResendUserPasswordRes
  restoreUser: ProvisionedUser
  resyncProviderAvailability: ResyncResponse
  revokeUser: User
  savePatientBilling?: Maybe<PatientBilling>
  savePatientBillingExternal: SavePatientBillingExternalOutput
  sendConsentPacket: SendConsentPacketResponse
  sendEligibilityVerification: ActionEntry
  sendOTP?: Maybe<ExternalResponse>
  signUpGoogleUser: ProvisionedUser
  signUpUser: ProvisionedUser
  syncToEmr: EmrSyncStatistics
  updateAppointment: Appointment
  updateDocuments: Array<Document>
  updateEmployment: Employment
  updateInsurancePlan: InsurancePlanFull
  updateInsurancePlanParticipant: InsurancePlanParticipant
  updateListItems: Array<IListItem>
  updatePatientBillingInsured: PatientBilling
  updatePatientIntegration: PatientIntegration
  updatePatientRegistrationSubmission: SubmissionResponse
  updatePayerEnrollments: Array<PayerEnrollment>
  updatePayers: Array<Payer>
  updateProfessionalHistory: Array<ProfessionalHistory>
  updateProvider: Provider
  updateProviderCredentialing: ProviderCredentialing
  updateProviderDocuments: Array<ProviderDocument>
  updateProviderLicenseRequests: Array<ProviderLicenseRequest>
  updateProviderLicenses: Array<ProviderLicense>
  updateReoccuranceTemplate: UpdateReoccuranceTemplateResponse
  updateSchedule: Schedule
  updateTaskV2: Task
  updateTasks: Array<Task>
  updateUser: ProvisionedUser
  updateVerifiedProviderDocuments: Array<ProviderDocument>
  upsertIdentifiers: Array<ProviderIdentifier>
  upsertProviderExternalAccounts: Array<ProviderExternalAccount>
  validateCaptchaAndMatch?: Maybe<MatchedTokenResponse>
  verifyEligibility: EligibilityVerification
}

export type MutationAddProviderLicenseRequestsArgs = {
  content: Array<ProviderLicenseRequestCreateInput>
  providerId: Scalars['ID']
}

export type MutationAppendDocumentsArgs = {
  content: Array<CreateDocumentInput>
  treatmentId: Scalars['ID']
}

export type MutationAppendInsurancePlanParticipantsArgs = {
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
  providerId: Scalars['ID']
}

export type MutationAppendListItemsArgs = {
  input: Array<AppendListItemInput>
  key: Scalars['String']
}

export type MutationAppendProviderDocumentsArgs = {
  content: Array<CreateProviderDocumentInput>
  providerId: Scalars['ID']
}

export type MutationAppendProviderLicensesArgs = {
  content: Array<ProviderLicenseCreateInput>
  providerId: Scalars['ID']
}

export type MutationAppendVerifiedProviderDocumentsArgs = {
  content: Array<CreateProviderDocumentInput>
  providerId: Scalars['ID']
}

export type MutationBulkUpdateInsurancePlansArgs = {
  content: Array<BulkInsurancePlanUpdateInput>
}

export type MutationCompletePatientRegistrationSubmissionArgs = {
  input: CompletePatientRegistrationSubmission
}

export type MutationConfirmOtpAndMatchArgs = {
  input: ConfirmOtpAndMatchInput
}

export type MutationCreateAppointmentArgs = {
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}

export type MutationCreateAppointmentV2Args = {
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}

export type MutationCreateInsurancePlanArgs = {
  content: InsurancePlanCreateInput
}

export type MutationCreatePatientRegistrationSubmissionArgs = {
  input: CreatePatientRegistrationSubmission
}

export type MutationCreatePayerEnrollmentsArgs = {
  content: Array<CreatePayerEnrollmentInput>
  providerId: Scalars['ID']
}

export type MutationCreatePayersArgs = {
  content: Array<PayerCreateInput>
}

export type MutationCreateProfessionalHistoryArgs = {
  content: Array<ProfessionalHistoryCreateInput>
  providerId: Scalars['ID']
}

export type MutationCreateProviderArgs = {
  content: ProviderInputCreate
}

export type MutationCreateScheduleArgs = {
  content: ScheduleInput
}

export type MutationCreateTaskArgs = {
  content: CreateTaskInput
}

export type MutationDecryptArgs = {
  input: DecryptInput
}

export type MutationDeleteAppointmentArgs = {
  _id: Scalars['ID']
}

export type MutationDeleteIdentifiersArgs = {
  identifierIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationDeleteInsurancePlanArgs = {
  _id: Scalars['ID']
}

export type MutationDeleteListItemsArgs = {
  input: Array<Scalars['ID']>
  key: Scalars['String']
}

export type MutationDeletePayerEnrollmentsArgs = {
  enrollmentIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationDeletePayersArgs = {
  content: Array<Scalars['ID']>
}

export type MutationDeleteProfessionalHistoryArgs = {
  ids: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationDeleteProviderArgs = {
  _id: Scalars['ID']
}

export type MutationDeleteProviderExternalAccountsArgs = {
  providerExternalAccountIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationDeleteScheduleArgs = {
  _id: Scalars['ID']
}

export type MutationDeleteTaskArgs = {
  _id: Scalars['ID']
}

export type MutationEncryptArgs = {
  input: EncryptInput
}

export type MutationGeneratePatientLinkArgs = {
  input: GeneratePatientLinkInput
}

export type MutationPatchSettingArgs = {
  key: Scalars['String']
  value: Scalars['AWSJSON']
}

export type MutationRemoveDocumentsArgs = {
  documentIds: Array<Scalars['ID']>
  treatmentId: Scalars['ID']
}

export type MutationRemoveInsurancePlanParticipantsArgs = {
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
  providerId: Scalars['ID']
}

export type MutationRemoveProviderDocumentsArgs = {
  documentIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationRemoveProviderLicenseRequestsArgs = {
  licenseIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationRemoveProviderLicensesArgs = {
  licenseIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationRemoveUserArgs = {
  _id: Scalars['String']
}

export type MutationRemoveVerifiedProviderDocumentsArgs = {
  documentIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type MutationResendUserPasswordArgs = {
  cognitoUserId: Scalars['ID']
}

export type MutationRestoreUserArgs = {
  _id: Scalars['String']
}

export type MutationResyncProviderAvailabilityArgs = {
  requests: Array<ResyncProviderAvailabilityRequest>
}

export type MutationRevokeUserArgs = {
  _id: Scalars['String']
}

export type MutationSavePatientBillingArgs = {
  forceSync?: InputMaybe<Scalars['Boolean']>
  input: UpdatePatientBillingInput
}

export type MutationSavePatientBillingExternalArgs = {
  input: SavePatientBillingExternalInput
}

export type MutationSendConsentPacketArgs = {
  content: SendConsentPacketInput
}

export type MutationSendEligibilityVerificationArgs = {
  input: SendEligibilityVerificationInput
}

export type MutationSendOtpArgs = {
  input: SendOtpInput
}

export type MutationSignUpGoogleUserArgs = {
  content: GoogleSignUpInput
}

export type MutationSignUpUserArgs = {
  content: UserSignUpInput
}

export type MutationSyncToEmrArgs = {
  input: SyncToEmrInput
}

export type MutationUpdateAppointmentArgs = {
  _id: Scalars['ID']
  content: UpdateAppointmentInput
  options?: InputMaybe<AppointmentOptions>
}

export type MutationUpdateDocumentsArgs = {
  content: Array<UpdateDocumentInput>
  treatmentId: Scalars['ID']
}

export type MutationUpdateEmploymentArgs = {
  _id?: InputMaybe<Scalars['ID']>
  content: EmploymentInput
  providerId?: InputMaybe<Scalars['ID']>
}

export type MutationUpdateInsurancePlanArgs = {
  _id: Scalars['ID']
  content: InsurancePlanUpdateInput
}

export type MutationUpdateInsurancePlanParticipantArgs = {
  content: InsurancePlanParticipantInput
  providerId: Scalars['ID']
}

export type MutationUpdateListItemsArgs = {
  input: Array<UpdateListItemInput>
  key: Scalars['String']
}

export type MutationUpdatePatientBillingInsuredArgs = {
  input: UpdatePatientBillingInsuredInput
}

export type MutationUpdatePatientIntegrationArgs = {
  content: PatientIntegrationInput
  treatmentId: Scalars['ID']
}

export type MutationUpdatePatientRegistrationSubmissionArgs = {
  input: UpdatePatientRegistrationSubmission
}

export type MutationUpdatePayerEnrollmentsArgs = {
  content: Array<UpdatePayerEnrollmentInput>
  providerId: Scalars['ID']
}

export type MutationUpdatePayersArgs = {
  content: Array<PayerUpdateInput>
}

export type MutationUpdateProfessionalHistoryArgs = {
  content: Array<ProfessionalHistoryUpdateInput>
  providerId: Scalars['ID']
}

export type MutationUpdateProviderArgs = {
  _id: Scalars['ID']
  content: ProviderInputUpdate
}

export type MutationUpdateProviderCredentialingArgs = {
  content: ProviderCredentialingInput
  providerId: Scalars['ID']
}

export type MutationUpdateProviderDocumentsArgs = {
  content: Array<UpdateProviderDocumentInput>
  providerId: Scalars['ID']
}

export type MutationUpdateProviderLicenseRequestsArgs = {
  content: Array<ProviderLicenseRequestUpdateInput>
  providerId: Scalars['ID']
}

export type MutationUpdateProviderLicensesArgs = {
  content: Array<ProviderLicenseUpdateInput>
  providerId: Scalars['ID']
}

export type MutationUpdateReoccuranceTemplateArgs = {
  content: ReoccuranceTemplateInput
  id: Scalars['ID']
}

export type MutationUpdateScheduleArgs = {
  _id: Scalars['ID']
  content: ScheduleInput
}

export type MutationUpdateTaskV2Args = {
  content: UpdateTaskInputV2
}

export type MutationUpdateTasksArgs = {
  content: Array<UpdateTaskInputV2>
}

export type MutationUpdateUserArgs = {
  cognitoUserId: Scalars['ID']
  content: UserUpdateInput
}

export type MutationUpdateVerifiedProviderDocumentsArgs = {
  content: Array<UpdateProviderDocumentInput>
  providerId: Scalars['ID']
}

export type MutationUpsertIdentifiersArgs = {
  content: Array<ProviderIdentifierInput>
  providerId: Scalars['ID']
}

export type MutationUpsertProviderExternalAccountsArgs = {
  content: Array<ProviderExternalAccountInput>
  providerId: Scalars['ID']
}

export type MutationValidateCaptchaAndMatchArgs = {
  input: ValidateCaptchaAndMatchInput
}

export type MutationVerifyEligibilityArgs = {
  input: VerifyEligibilityInput
}

export type Node = {
  _id: Scalars['ID']
}

export enum NoticeCode {
  EligibilityNotVerified = 'ELIGIBILITY_NOT_VERIFIED',
  EmrsyncError = 'EMRSYNC__ERROR',
  EmrsyncImportantUnsynced = 'EMRSYNC__IMPORTANT_UNSYNCED',
  EmrsyncInProgress = 'EMRSYNC__IN_PROGRESS',
  EmrsyncPartialUnsynced = 'EMRSYNC__PARTIAL_UNSYNCED',
  EmrsyncSynced = 'EMRSYNC__SYNCED',
  EmrsyncUnknown = 'EMRSYNC__UNKNOWN',
  MissingConsent = 'MISSING_CONSENT',
  MissingCreditCard = 'MISSING_CREDIT_CARD',
  PriorAuthRequired = 'PRIOR_AUTH_REQUIRED',
}

export enum NoticeLevel {
  Error = 'error',
  ErrorDark = 'error_dark',
  ErrorLight = 'error_light',
  Info = 'info',
  InfoDark = 'info_dark',
  InfoLight = 'info_light',
  Primary = 'primary',
  PrimaryDark = 'primary_dark',
  PrimaryLight = 'primary_light',
  Secondary = 'secondary',
  SecondaryDark = 'secondary_dark',
  SecondaryLight = 'secondary_light',
  Success = 'success',
  SuccessDark = 'success_dark',
  SuccessLight = 'success_light',
  Warning = 'warning',
  WarningDark = 'warning_dark',
  WarningLight = 'warning_light',
}

export enum OtpMethod {
  Call = 'CALL',
  Sms = 'SMS',
}

export type OpenSearchRes = {
  aggregations?: Maybe<Scalars['AWSJSON']>
  from?: Maybe<Scalars['Int']>
  resultCount: Scalars['Int']
  searchAfter?: Maybe<Scalars['AWSJSON']>
}

export enum Operator {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
}

export type OutOfNetworkPlanInput = {
  name: Scalars['String']
  state: StateInput
}

export type Participant = {
  actor: Reference
  required: Scalars['Boolean']
  status?: Maybe<ParticipationStatus>
  type?: Maybe<AppointmentParticipantType>
}

export type ParticipantInput = {
  actor: ReferenceInput
  required: Scalars['Boolean']
  status?: InputMaybe<ParticipationStatus>
  type?: InputMaybe<AppointmentParticipantTypeCode>
}

export enum ParticipationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NeedsAction = 'NEEDS_ACTION',
  Tentative = 'TENTATIVE',
}

export type Patient = {
  integration?: Maybe<PatientIntegration>
}

export type PatientAddress = {
  city?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  zipcode?: Maybe<Scalars['String']>
}

export type PatientBilling = {
  comments?: Maybe<Array<Annotation>>
  consentPacketInfo?: Maybe<ConsentPacketInfo>
  creditCardOnFile?: Maybe<Scalars['Boolean']>
  emrSyncStatistics?: Maybe<EmrSyncStatistics>
  fullConsentPackedSigned?: Maybe<Scalars['Boolean']>
  hasBillableAppointment?: Maybe<Scalars['Boolean']>
  id: Scalars['String']
  idFile?: Maybe<File>
  idRelationship?: Maybe<PatientRelationshipToIdCard>
  idType?: Maybe<IdentificationType>
  idValue?: Maybe<Scalars['String']>
  insurances?: Maybe<Array<BillingInsured>>
  patientId: Scalars['String']
  selfPay?: Maybe<Scalars['Boolean']>
  treatmentId: Scalars['String']
}

export type PatientBillingInsurance = {
  addressComponents?: Maybe<AddressComponents>
  coPay?: Maybe<Scalars['String']>
  dateOfBirth?: Maybe<Scalars['AWSDate']>
  effectiveDate?: Maybe<Scalars['AWSDate']>
  eligibilityReason?: Maybe<Scalars['String']>
  eligibilityVerified?: Maybe<Scalars['Boolean']>
  emrSyncStatus?: Maybe<EmrSyncStatusCode>
  expirationDate?: Maybe<Scalars['AWSDate']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  idNumber?: Maybe<Scalars['String']>
  insurancePlanId?: Maybe<Scalars['ID']>
  lastName?: Maybe<Scalars['String']>
  legalSex?: Maybe<PatientLegalSex>
  medicaidIdNumber?: Maybe<Scalars['String']>
  medicareIdNumber?: Maybe<Scalars['String']>
  middleInitial?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  outOfNetwork?: Maybe<Scalars['Boolean']>
  outOfNetworkPlan?: Maybe<OutOfNetworkPlan>
  phone?: Maybe<Scalars['String']>
  policyGroupFecaNumber?: Maybe<Scalars['String']>
  policyGroupName?: Maybe<Scalars['String']>
  priorAuthRequired?: Maybe<PriorAuthStatus>
  relationship?: Maybe<PatientRelationshipToInsured>
  type: InsuranceOrdinality
}

export enum PatientContactRelation {
  AdditionalPatientContact = 'Additional Patient Contact',
  MinorPatient = 'Minor Patient',
  Other = 'Other',
  ParentGuardian = 'Parent/Guardian',
  SupportiveContact = 'Supportive Contact',
}

export enum PatientContactUse {
  Emergency = 'emergency',
  Personal = 'personal',
  Work = 'work',
}

export enum PatientGenderIdentity {
  Female = 'female',
  Genderqueer = 'genderqueer',
  Male = 'male',
  NonBinary = 'nonBinary',
  NoneDisclose = 'noneDisclose',
  Other = 'other',
  TransgenderFemale = 'transgenderFemale',
  TransgenderMale = 'transgenderMale',
}

export type PatientIntegration = {
  emrId?: Maybe<Scalars['ID']>
  isActive: Scalars['Boolean']
}

export type PatientIntegrationInput = {
  emrId?: InputMaybe<Scalars['ID']>
  forceOverwrite?: InputMaybe<Scalars['Boolean']>
  isActive?: InputMaybe<Scalars['Boolean']>
}

export enum PatientLegalSex {
  F = 'f',
  M = 'm',
  O = 'o',
}

export type PatientLink = {
  fullLink: Scalars['String']
  shortLink: Scalars['String']
}

export type PatientMetaData = {
  display?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  mrn?: Maybe<Scalars['String']>
}

export type PatientMetaDataInput = {
  display?: InputMaybe<Scalars['String']>
  mrn?: InputMaybe<Scalars['String']>
}

export type PatientName = {
  firstName: Scalars['String']
  fullName: Scalars['String']
  lastName: Scalars['String']
  middleName?: Maybe<Scalars['String']>
  preferredName?: Maybe<Scalars['String']>
}

export type PatientNotice = {
  at?: Maybe<Scalars['AWSDateTime']>
  code: NoticeCode
  label: Scalars['String']
  level: NoticeLevel
}

export enum PatientOnboardingTaskType {
  NewPatientReferral = 'NEW_PATIENT_REFERRAL',
  NewPatientSelf = 'NEW_PATIENT_SELF',
  NewPatientToc = 'NEW_PATIENT_TOC',
}

export enum PatientRelationshipToIdCard {
  ParentGuardian = 'parent_guardian',
  Self = 'self',
}

export enum PatientRelationshipToInsured {
  Other = 'other',
  ParentGuardian = 'parent_guardian',
  Self = 'self',
  Spouse = 'spouse',
}

export type PatientSettings = {
  flags?: Maybe<PatientSettingsFlags>
}

export type PatientSettingsFlags = {
  suppressDischargeNotifications?: Maybe<Scalars['Boolean']>
}

export enum PatientStatus {
  Active = 'active',
  AwaitingInitial = 'awaitingInitial',
  ClosedDischarged = 'closedDischarged',
  Lead = 'lead',
  Pending = 'pending',
  Waitlist = 'waitlist',
}

export type PatientSummary = {
  display: PatientSummaryDisplayNames
  email?: Maybe<Scalars['String']>
  patientId: Scalars['ID']
  phoneNumber?: Maybe<Scalars['String']>
  status: PatientStatus
  treatmentId: Scalars['ID']
  userId: Scalars['ID']
}

export type PatientSummaryDisplayNames = {
  expandedName?: Maybe<Scalars['String']>
  fullName?: Maybe<Scalars['String']>
  legalName?: Maybe<Scalars['String']>
}

export type PatternTemplate = {
  interval: Scalars['Int']
  offset: Scalars['Int']
}

export type Payer = {
  comments?: Maybe<Array<Annotation>>
  id: Scalars['ID']
  name: Scalars['String']
  note?: Maybe<Scalars['String']>
  stateCode: Scalars['String']
  status: PayerStatus
}

export type PayerCreateInput = {
  comment?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  note?: InputMaybe<Scalars['String']>
  stateCode: Scalars['String']
  status?: InputMaybe<PayerStatus>
}

export type PayerEnrollment = {
  comments?: Maybe<Array<AttachmentAnnotation>>
  created: AuditEntry
  effectiveDate?: Maybe<Scalars['AWSDate']>
  entity?: Maybe<Scalars['String']>
  expirationDate?: Maybe<Scalars['AWSDate']>
  id: Scalars['ID']
  payer: Payer
  payerExternalProviderId?: Maybe<Scalars['String']>
  recredentialingDate?: Maybe<Scalars['AWSDate']>
  status: PayerEnrollmentStatus
  submissionDate?: Maybe<Scalars['AWSDate']>
  terminationDate?: Maybe<Scalars['AWSDate']>
  updated?: Maybe<AuditEntry>
  vendor?: Maybe<Scalars['String']>
}

export enum PayerEnrollmentStatus {
  AwaitingPrerequisite = 'AWAITING_PREREQUISITE',
  EmailedRequest = 'EMAILED_REQUEST',
  MissingInfo = 'MISSING_INFO',
  Na = 'NA',
  NaNonResident = 'NA_NON_RESIDENT',
  NeedToApply = 'NEED_TO_APPLY',
  OnHold = 'ON_HOLD',
  ParAndLinkedToGroup = 'PAR_AND_LINKED_TO_GROUP',
  PendingReassignment = 'PENDING_REASSIGNMENT',
  SubmittedToPlan = 'SUBMITTED_TO_PLAN',
}

export enum PayerStatus {
  Active = 'ACTIVE',
  ContractInProgress = 'CONTRACT_IN_PROGRESS',
  GroupInProgress = 'GROUP_IN_PROGRESS',
  Inactive = 'INACTIVE',
  OnHold = 'ON_HOLD',
}

export type PayerUpdateInput = {
  comment?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  name: Scalars['String']
  note?: InputMaybe<Scalars['String']>
  stateCode?: InputMaybe<Scalars['String']>
  status?: InputMaybe<PayerStatus>
}

export type Period = {
  endDate?: Maybe<Scalars['AWSDateTime']>
  startDate?: Maybe<Scalars['AWSDateTime']>
}

export type PeriodInput = {
  endDate?: InputMaybe<Scalars['AWSDateTime']>
  startDate?: InputMaybe<Scalars['AWSDateTime']>
}

export type PracticeState = {
  availabilityStatus: PracticeStateAvailabilityStatus
  entityName: Scalars['String']
  groupNpi: Scalars['String']
  id: Scalars['ID']
  qualifyingPayerLicenseTypes: Array<LicenseType>
  stateCode: Scalars['String']
  taxId: Scalars['String']
}

export enum PracticeStateAvailabilityStatus {
  All = 'ALL',
  ExistingPatientsOnly = 'EXISTING_PATIENTS_ONLY',
}

export enum PriorAuthStatus {
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED',
  Satisfied = 'SATISFIED',
  Unknown = 'UNKNOWN',
}

export enum ProfessionCategory {
  Certification = 'CERTIFICATION',
  Education = 'EDUCATION',
  LicensureExam = 'LICENSURE_EXAM',
  Training = 'TRAINING',
  WorkExperience = 'WORK_EXPERIENCE',
}

export enum ProfessionCode {
  Do = 'DO',
  Lcsw = 'LCSW',
  Lcswa = 'LCSWA',
  Licsw = 'LICSW',
  Lmhc = 'LMHC',
  Lmhca = 'LMHCA',
  Lmsw = 'LMSW',
  Lpc = 'LPC',
  Lsw = 'LSW',
  Lswaic = 'LSWAIC',
  Md = 'MD',
  Np = 'NP',
  Other = 'OTHER',
  Phd = 'PHD',
  Pmnph = 'PMNPH',
  Psyd = 'PSYD',
}

export type ProfessionalHistory = {
  address?: Maybe<InternationalAddress>
  category: ProfessionCategory
  certificationNumber?: Maybe<Scalars['String']>
  completed?: Maybe<Scalars['Boolean']>
  created: AuditEntry
  degree?: Maybe<Scalars['String']>
  endDate?: Maybe<Scalars['AWSDate']>
  examDate?: Maybe<Scalars['AWSDate']>
  examType?: Maybe<Scalars['String']>
  id: Scalars['ID']
  institutionName?: Maybe<Scalars['String']>
  modified?: Maybe<AuditEntry>
  notes?: Maybe<Scalars['String']>
  numberOfAttempts?: Maybe<Scalars['Int']>
  organizationName?: Maybe<Scalars['String']>
  programType?: Maybe<Scalars['String']>
  recertificationDate?: Maybe<Scalars['AWSDate']>
  specialty?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['AWSDate']>
  title?: Maybe<Scalars['String']>
}

export type ProfessionalHistoryCreateInput = {
  address?: InputMaybe<InternationalAddressInput>
  category: ProfessionCategory
  certificationNumber?: InputMaybe<Scalars['String']>
  completed?: InputMaybe<Scalars['Boolean']>
  degree?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['AWSDate']>
  examDate?: InputMaybe<Scalars['AWSDate']>
  examType?: InputMaybe<Scalars['String']>
  institutionName?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  numberOfAttempts?: InputMaybe<Scalars['Int']>
  organizationName?: InputMaybe<Scalars['String']>
  programType?: InputMaybe<Scalars['String']>
  recertificationDate?: InputMaybe<Scalars['AWSDate']>
  specialty?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['AWSDate']>
  title?: InputMaybe<Scalars['String']>
}

export type ProfessionalHistoryUpdateInput = {
  address?: InputMaybe<InternationalAddressInput>
  certificationNumber?: InputMaybe<Scalars['String']>
  completed?: InputMaybe<Scalars['Boolean']>
  degree?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['AWSDate']>
  examDate?: InputMaybe<Scalars['AWSDate']>
  examType?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  institutionName?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  numberOfAttempts?: InputMaybe<Scalars['Int']>
  organizationName?: InputMaybe<Scalars['String']>
  programType?: InputMaybe<Scalars['String']>
  recertificationDate?: InputMaybe<Scalars['AWSDate']>
  specialty?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['AWSDate']>
  title?: InputMaybe<Scalars['String']>
}

export type ProgramFlags = {
  isWellness: Scalars['Boolean']
}

export type ProgramSettings = {
  appointmentSettings?: Maybe<AppointmentSettings>
  flags?: Maybe<ProgramFlags>
  lists?: Maybe<ProgramSettingsLists>
  patientSettings?: Maybe<PatientSettings>
  providerSettings?: Maybe<ProviderSettings>
}

export type ProgramSettingsLists = {
  contactTypes?: Maybe<Array<StandardListItem>>
  dischargeReasons?: Maybe<Array<StandardListItem>>
  taxonomyCodes?: Maybe<Array<StandardListItem>>
}

export type Provider = {
  _id: Scalars['ID']
  ages?: Maybe<Array<Scalars['String']>>
  availability: Availability
  availabilityNotes?: Maybe<Scalars['String']>
  bio?: Maybe<Scalars['String']>
  careCoordinator?: Maybe<Reference>
  careManagerId?: Maybe<Scalars['ID']>
  clinicalAges?: Maybe<Array<Scalars['String']>>
  clinicalModalities?: Maybe<Array<Scalars['String']>>
  clinicalSpecialties?: Maybe<Array<Scalars['String']>>
  communityIdentity?: Maybe<Array<CommunityIdentity>>
  display?: Maybe<UserSummaryDisplayNames>
  email?: Maybe<Scalars['String']>
  employment?: Maybe<Employment>
  ethnicity?: Maybe<Ethnicity>
  expectedHours?: Maybe<Array<ExpectedHours>>
  firstName?: Maybe<Scalars['String']>
  genderIdentity?: Maybe<GenderIdentity>
  identifiers?: Maybe<Array<ProviderIdentifier>>
  insurancePlans?: Maybe<Array<InsurancePlanParticipant>>
  languages?: Maybe<Array<Scalars['String']>>
  lastName?: Maybe<Scalars['String']>
  licenseRequests?: Maybe<Array<ProviderLicenseRequest>>
  licenses?: Maybe<Array<ProviderLicense>>
  modalities?: Maybe<Array<Scalars['String']>>
  race?: Maybe<Array<Race>>
  serviceTypes?: Maybe<Array<ProviderServiceType>>
  sort?: Maybe<Scalars['AWSJSON']>
  specialties?: Maybe<Array<Scalars['String']>>
  spirituality?: Maybe<Array<Scalars['String']>>
  status: ProviderStatus
  supervisees?: Maybe<Array<Reference>>
  supervisor?: Maybe<Reference>
  teamLead?: Maybe<Reference>
}

export type ProviderCredentialing = {
  address?: Maybe<InternationalAddress>
  birthCountry?: Maybe<Scalars['String']>
  dateOfBirth?: Maybe<Scalars['AWSDate']>
  firstName?: Maybe<Scalars['String']>
  isUSCitizen?: Maybe<Scalars['Boolean']>
  lastName?: Maybe<Scalars['String']>
  middleName?: Maybe<Scalars['String']>
  personalEmail?: Maybe<Scalars['String']>
  primaryPhone?: Maybe<Scalars['String']>
  priorLastName?: Maybe<Scalars['String']>
  ssn?: Maybe<EncryptedValue>
  suffix?: Maybe<Scalars['String']>
}

export type ProviderCredentialingInput = {
  birthCountry?: InputMaybe<Scalars['String']>
  isUSCitizen?: InputMaybe<Scalars['Boolean']>
  ssn?: InputMaybe<Scalars['String']>
  suffix?: InputMaybe<Scalars['String']>
}

export type ProviderDocument = {
  created: AuditEntry
  documentCategory: DocumentCategory
  file: File
  id: Scalars['ID']
  modified?: Maybe<AuditEntry>
  stateCode?: Maybe<Scalars['String']>
  status?: Maybe<DocumentVerificationStatus>
  statusUpdated?: Maybe<AuditEntry>
}

export type ProviderExternalAccount = {
  id: Scalars['String']
  note?: Maybe<Scalars['String']>
  password?: Maybe<EncryptedValue>
  type: Scalars['String']
  username: Scalars['String']
}

export type ProviderExternalAccountInput = {
  id?: InputMaybe<Scalars['ID']>
  note?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  username?: InputMaybe<Scalars['String']>
}

export type ProviderFlags = {
  vaultActive?: Maybe<Scalars['Boolean']>
}

export type ProviderIdentifier = {
  effectiveDate?: Maybe<Scalars['AWSDate']>
  expirationDate?: Maybe<Scalars['AWSDate']>
  id: Scalars['ID']
  type: ProviderIdentifierType
  value: Scalars['String']
}

export type ProviderIdentifierInput = {
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  id?: InputMaybe<Scalars['ID']>
  type?: InputMaybe<ProviderIdentifierType>
  value?: InputMaybe<Scalars['String']>
}

export enum ProviderIdentifierType {
  CaqhId = 'CAQH_ID',
  Npi = 'NPI',
  PrimaryCmsTaxonomy = 'PRIMARY_CMS_TAXONOMY',
  SecondaryCmsTaxonomy = 'SECONDARY_CMS_TAXONOMY',
}

export type ProviderInputCreate = {
  ages?: InputMaybe<Array<Scalars['String']>>
  availability: Availability
  availabilityNotes?: InputMaybe<Scalars['String']>
  bio?: InputMaybe<Scalars['String']>
  careCoordinatorId?: InputMaybe<Scalars['ID']>
  careManagerId: Scalars['ID']
  clinicalAges?: InputMaybe<Array<Scalars['String']>>
  clinicalModalities?: InputMaybe<Array<Scalars['String']>>
  clinicalSpecialties?: InputMaybe<Array<Scalars['String']>>
  communityIdentity?: InputMaybe<Array<CommunityIdentity>>
  email?: InputMaybe<Scalars['String']>
  employment?: InputMaybe<EmploymentInput>
  ethnicity?: InputMaybe<Ethnicity>
  expectedHours?: InputMaybe<Array<ExpectedHoursInput>>
  firstName?: InputMaybe<Scalars['String']>
  genderIdentity?: InputMaybe<GenderIdentity>
  identifiers?: InputMaybe<Array<ProviderIdentifierInput>>
  insurancePlans?: InputMaybe<Array<InsurancePlanParticipantInput>>
  languages?: InputMaybe<Array<Scalars['String']>>
  lastName?: InputMaybe<Scalars['String']>
  modalities?: InputMaybe<Array<Scalars['String']>>
  race?: InputMaybe<Array<Race>>
  serviceTypes?: InputMaybe<Array<ProviderServiceType>>
  specialties?: InputMaybe<Array<Scalars['String']>>
  spirituality?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<ProviderStatus>
  supervisorId?: InputMaybe<Scalars['ID']>
}

export type ProviderInputUpdate = {
  ages?: InputMaybe<Array<Scalars['String']>>
  availability?: InputMaybe<Availability>
  availabilityNotes?: InputMaybe<Scalars['String']>
  bio?: InputMaybe<Scalars['String']>
  careCoordinatorId?: InputMaybe<Scalars['ID']>
  clinicalAges?: InputMaybe<Array<Scalars['String']>>
  clinicalModalities?: InputMaybe<Array<Scalars['String']>>
  clinicalSpecialties?: InputMaybe<Array<Scalars['String']>>
  communityIdentity?: InputMaybe<Array<CommunityIdentity>>
  email?: InputMaybe<Scalars['String']>
  employment?: InputMaybe<EmploymentInput>
  ethnicity?: InputMaybe<Ethnicity>
  expectedHours?: InputMaybe<Array<ExpectedHoursInput>>
  firstName?: InputMaybe<Scalars['String']>
  genderIdentity?: InputMaybe<GenderIdentity>
  identifiers?: InputMaybe<Array<ProviderIdentifierInput>>
  insurancePlans?: InputMaybe<Array<InsurancePlanParticipantInput>>
  languages?: InputMaybe<Array<Scalars['String']>>
  lastName?: InputMaybe<Scalars['String']>
  modalities?: InputMaybe<Array<Scalars['String']>>
  race?: InputMaybe<Array<Race>>
  serviceTypes?: InputMaybe<Array<ProviderServiceType>>
  specialties?: InputMaybe<Array<Scalars['String']>>
  spirituality?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<ProviderStatus>
  supervisorId?: InputMaybe<Scalars['ID']>
}

export type ProviderLicense = {
  created: AuditEntry
  durationType?: Maybe<LicenseDurationType>
  excludeFromPayerEnrollment: Scalars['Boolean']
  expirationDate?: Maybe<Scalars['AWSDate']>
  id: Scalars['ID']
  issueDate?: Maybe<Scalars['AWSDate']>
  licenseType: LicenseType
  modified?: Maybe<AuditEntry>
  number: Scalars['String']
  stateCode: Scalars['String']
  status: ActiveStatus
}

export type ProviderLicenseCreateInput = {
  durationType?: InputMaybe<LicenseDurationType>
  excludeFromPayerEnrollment?: InputMaybe<Scalars['Boolean']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  issueDate?: InputMaybe<Scalars['AWSDate']>
  licenseType: LicenseType
  number: Scalars['String']
  stateCode: Scalars['String']
  status: ActiveStatus
}

export type ProviderLicenseRequest = {
  comments?: Maybe<Array<Annotation>>
  completeDate?: Maybe<Scalars['AWSDate']>
  created: AuditEntry
  durationType?: Maybe<LicenseDurationType>
  id: Scalars['ID']
  licenseType: LicenseType
  modified?: Maybe<AuditEntry>
  psvSubmitDate?: Maybe<Scalars['AWSDate']>
  requestType: LicenseRequestType
  stateCode: Scalars['String']
  status: LicenseRequestStatus
  submitDate?: Maybe<Scalars['AWSDate']>
}

export type ProviderLicenseRequestCreateInput = {
  comment?: InputMaybe<Scalars['String']>
  completeDate?: InputMaybe<Scalars['AWSDate']>
  durationType?: InputMaybe<LicenseDurationType>
  licenseType: LicenseType
  psvSubmitDate?: InputMaybe<Scalars['AWSDate']>
  requestType: LicenseRequestType
  stateCode: Scalars['String']
  status: LicenseRequestStatus
  submitDate?: InputMaybe<Scalars['AWSDate']>
}

export type ProviderLicenseRequestUpdateInput = {
  comment?: InputMaybe<Scalars['String']>
  completeDate?: InputMaybe<Scalars['AWSDate']>
  durationType?: InputMaybe<LicenseDurationType>
  id: Scalars['ID']
  licenseType?: InputMaybe<LicenseType>
  psvSubmitDate?: InputMaybe<Scalars['AWSDate']>
  requestType?: InputMaybe<LicenseRequestType>
  stateCode?: InputMaybe<Scalars['String']>
  status?: InputMaybe<LicenseRequestStatus>
  submitDate?: InputMaybe<Scalars['AWSDate']>
}

export type ProviderLicenseUpdateInput = {
  durationType?: InputMaybe<LicenseDurationType>
  excludeFromPayerEnrollment?: InputMaybe<Scalars['Boolean']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  id: Scalars['ID']
  issueDate?: InputMaybe<Scalars['AWSDate']>
  licenseType?: InputMaybe<LicenseType>
  number?: InputMaybe<Scalars['String']>
  stateCode?: InputMaybe<Scalars['String']>
  status?: InputMaybe<ActiveStatus>
}

export type ProviderPlanParticipant = {
  _id: Scalars['ID']
  billingRelationship: InsurancePlanBillingRelationship
  effectiveDate?: Maybe<Scalars['AWSDate']>
  insurancePlan: InsurancePlanPartial
  participatingProvider: Reference
  status?: Maybe<ActiveStatus>
  terminationDate?: Maybe<Scalars['AWSDate']>
}

export enum ProviderServiceType {
  GroupTherapy = 'GROUP_THERAPY',
  MedMgmt = 'MED_MGMT',
  Therapy = 'THERAPY',
}

export type ProviderSettings = {
  flags?: Maybe<ProviderFlags>
  specialties?: Maybe<Array<StandardListItem>>
}

export enum ProviderStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type ProvisionedUser = {
  careManager: CareManagerUser
  cognito: Cognito
  permitRoles?: Maybe<Array<Scalars['ID']>>
}

export type Query = {
  describePatientsById: Array<PatientSummary>
  describePatientsByTreatmentId: Array<PatientSummary>
  describePatientsByUserId: Array<PatientSummary>
  describeUsersByCareManagerId: Array<UserSummary>
  describeUsersByCognitoUserId: Array<UserSummary>
  describeUsersByEmrId: Array<UserSummary>
  describeUsersById: Array<UserSummary>
  describeUsersByProviderId: Array<UserSummary>
  getAppointment?: Maybe<Appointment>
  getConfig: Array<ConfigItem>
  getDocument: Document
  getDocumentsByTreatmentId: Array<Document>
  getEmployment: Employment
  getEmploymentByProviderId: Employment
  getEmployments: Array<Employment>
  getExternalInsurancePlans: Array<InsurancePlanExternal>
  getExternalLanguages: Array<Language>
  getExternalPracticeStates: Array<PracticeState>
  getInheritingProviders: Array<ProviderPlanParticipant>
  getInsurancePlans: Array<InsurancePlanFull>
  getList: Array<ListResponse>
  getLocations: Array<Location>
  getOutOfNetworkInsurancePlans: Array<InsurancePlanFull>
  getPatientByTreatmentId: Patient
  getPayerEnrollmentsByProviderId: Array<PayerEnrollment>
  getPayers: Array<Payer>
  getPracticeStates: Array<PracticeState>
  getProfessionalHistory: Array<ProfessionalHistory>
  getProfessionalHistoryById: ProfessionalHistory
  getProgramSettings: ProgramSettings
  getProvider: Provider
  getProviderByCareManagerId: Provider
  getProviderCredentialing: ProviderCredentialing
  getProviderDocument: ProviderDocument
  getProviderDocumentsByProviderId: Array<ProviderDocument>
  getProviderExternalAccounts: Array<ProviderExternalAccount>
  getProviders: Array<Provider>
  getSchedule?: Maybe<Schedule>
  getTask: Task
  getTasks: Array<Task>
  getTasksByTreatmentIds: Array<Task>
  getUser: User
  getUserById: User
  getUsers?: Maybe<Array<User>>
  getVerifiedProviderDocument: ProviderDocument
  getVerifiedProviderDocumentsByProviderId: Array<ProviderDocument>
  listEligibilityVerifications: Array<EligibilityVerification>
  listPatientEligibilityVerifications: Array<EligibilityVerification>
  listSecurityRoles: Array<SecurityRoleResponse>
  listStates?: Maybe<Array<Maybe<State>>>
  loadEligibilityVerification?: Maybe<EligibilityVerification>
  loadPatientBilling?: Maybe<PatientBilling>
  searchAppointments?: Maybe<AppointmentResponse>
  searchPatients: SearchPatientsResponse
  searchProviders: SearchProvidersResponse
  searchSchedules?: Maybe<ScheduleResponse>
  searchTasks: TaskResponse
  timeSlotSearch: TimeSlotSearchRes
}

export type QueryDescribePatientsByIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  patientIds: Array<Scalars['String']>
}

export type QueryDescribePatientsByTreatmentIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  treatmentIds: Array<Scalars['String']>
}

export type QueryDescribePatientsByUserIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  userIds: Array<Scalars['String']>
}

export type QueryDescribeUsersByCareManagerIdArgs = {
  careManagerIds: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}

export type QueryDescribeUsersByCognitoUserIdArgs = {
  cognitoUserIds: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}

export type QueryDescribeUsersByEmrIdArgs = {
  emrIds: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}

export type QueryDescribeUsersByIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  userIds: Array<Scalars['String']>
}

export type QueryDescribeUsersByProviderIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  providerIds: Array<Scalars['String']>
}

export type QueryGetAppointmentArgs = {
  _id: Scalars['ID']
}

export type QueryGetConfigArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  keys: Array<Scalars['String']>
}

export type QueryGetDocumentArgs = {
  documentId: Scalars['ID']
  treatmentId: Scalars['ID']
}

export type QueryGetDocumentsByTreatmentIdArgs = {
  treatmentId: Scalars['ID']
}

export type QueryGetEmploymentArgs = {
  _id: Scalars['ID']
}

export type QueryGetEmploymentByProviderIdArgs = {
  providerId: Scalars['ID']
}

export type QueryGetExternalPracticeStatesArgs = {
  input: GetExternalPracticeStatesInput
}

export type QueryGetInheritingProvidersArgs = {
  insurancePlanIds: Array<Scalars['ID']>
  providerId: Scalars['ID']
}

export type QueryGetListArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
  keys: Array<Scalars['String']>
}

export type QueryGetPatientByTreatmentIdArgs = {
  treatmentId: Scalars['ID']
}

export type QueryGetPayerEnrollmentsByProviderIdArgs = {
  providerId: Scalars['ID']
}

export type QueryGetProfessionalHistoryArgs = {
  providerId: Scalars['ID']
}

export type QueryGetProfessionalHistoryByIdArgs = {
  id: Scalars['ID']
}

export type QueryGetProgramSettingsArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}

export type QueryGetProviderArgs = {
  _id: Scalars['ID']
}

export type QueryGetProviderByCareManagerIdArgs = {
  careManagerId: Scalars['ID']
}

export type QueryGetProviderCredentialingArgs = {
  providerId: Scalars['ID']
}

export type QueryGetProviderDocumentArgs = {
  documentId: Scalars['ID']
  providerId: Scalars['ID']
}

export type QueryGetProviderDocumentsByProviderIdArgs = {
  providerId: Scalars['ID']
}

export type QueryGetProviderExternalAccountsArgs = {
  providerId: Scalars['ID']
}

export type QueryGetProvidersArgs = {
  pageSize?: InputMaybe<Scalars['Int']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
}

export type QueryGetScheduleArgs = {
  _id: Scalars['ID']
}

export type QueryGetTaskArgs = {
  _id: Scalars['ID']
}

export type QueryGetTasksByTreatmentIdsArgs = {
  treatmentIds: Array<Scalars['ID']>
}

export type QueryGetUserArgs = {
  email: Scalars['String']
}

export type QueryGetUserByIdArgs = {
  content: GetUserByIdInput
}

export type QueryGetVerifiedProviderDocumentArgs = {
  documentId: Scalars['ID']
  providerId: Scalars['ID']
}

export type QueryGetVerifiedProviderDocumentsByProviderIdArgs = {
  providerId: Scalars['ID']
}

export type QueryListEligibilityVerificationsArgs = {
  input: ListEligibilityVerificationInput
}

export type QueryListPatientEligibilityVerificationsArgs = {
  input: ListPatientEligibilityVerificationInput
}

export type QueryLoadEligibilityVerificationArgs = {
  input: LoadEligibilityVerificationInput
}

export type QueryLoadPatientBillingArgs = {
  input: LoadPatientBillingInput
}

export type QuerySearchAppointmentsArgs = {
  content?: InputMaybe<Array<SearchFilter>>
  pageSize?: InputMaybe<Scalars['Int']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Array<SortParam>>
}

export type QuerySearchPatientsArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  from?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  query: Scalars['AWSJSON']
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Scalars['AWSJSON']>
}

export type QuerySearchProvidersArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  from?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  query: Scalars['AWSJSON']
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Scalars['AWSJSON']>
}

export type QuerySearchSchedulesArgs = {
  content?: InputMaybe<Array<SearchFilter>>
  pageSize?: InputMaybe<Scalars['Int']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Array<SortParam>>
}

export type QuerySearchTasksArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  from?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  query: Scalars['AWSJSON']
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Scalars['AWSJSON']>
}

export type QueryTimeSlotSearchArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  from?: InputMaybe<Scalars['Int']>
  pageSize?: InputMaybe<Scalars['Int']>
  query: Scalars['AWSJSON']
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Scalars['AWSJSON']>
}

export enum Race {
  Asian = 'ASIAN',
  Black = 'BLACK',
  Native = 'NATIVE',
  PacificIslander = 'PACIFIC_ISLANDER',
  White = 'WHITE',
}

export type Reference = {
  _id?: Maybe<Scalars['ID']>
  active?: Maybe<Scalars['Boolean']>
  display?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  reference?: Maybe<Scalars['String']>
  type: ResourceType
}

export type ReferenceInput = {
  _id: Scalars['String']
  type: ResourceType
}

export type ReferrerInformation = {
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber: Scalars['String']
}

export type ReoccuranceTemplate = {
  id: Scalars['ID']
  lastOccuranceIndex?: Maybe<Scalars['Int']>
  monthlyTemplate?: Maybe<Array<MonthlyTemplate>>
  occuranceCount?: Maybe<Scalars['Int']>
  planningHorizon: Period
  reoccuranceType: ReoccuranceType
  timezone: Scalars['String']
  weeklyTemplate?: Maybe<Array<WeeklyTemplate>>
}

export type ReoccuranceTemplateInput = {
  monthlyTemplate?: InputMaybe<Array<MonthlyTemplateInput>>
  occuranceCount?: InputMaybe<Scalars['Int']>
  planningHorizon: PeriodInput
  reoccuranceType: ReoccuranceType
  timezone: Scalars['String']
  weeklyTemplate?: InputMaybe<Array<WeeklyTemplateInput>>
}

export type ReoccuranceTemplateSummary = {
  planningHorizon: Period
  timezone: Scalars['String']
}

export enum ReoccuranceType {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type ResendUserPasswordRes = {
  isSuccess: Scalars['Boolean']
}

export enum ResourceType {
  Caremanager = 'CAREMANAGER',
  Cognito = 'COGNITO',
  Location = 'LOCATION',
  Patient = 'PATIENT',
  Practitioner = 'PRACTITIONER',
}

export type ResyncProviderAvailabilityRequest = {
  careManagerId?: InputMaybe<Scalars['ID']>
  providerId?: InputMaybe<Scalars['ID']>
}

export type ResyncResponse = {
  message?: Maybe<Scalars['String']>
}

export type SavePatientBillingExternalInput = {
  idFile?: InputMaybe<FileCreate>
  insurances?: InputMaybe<Array<UpdateBillingExternalInput>>
}

export type SavePatientBillingExternalOutput = {
  id: Scalars['String']
  success: Scalars['Boolean']
}

export type Schedule = Node & {
  _id: Scalars['ID']
  active: Scalars['Boolean']
  actors: Array<Reference>
  name?: Maybe<Scalars['String']>
  notes?: Maybe<Array<Annotation>>
  reoccuranceTemplate: ReoccuranceTemplate
  serviceCategory: ServiceCategory
  serviceType: ServiceType
  subjectLimit: Scalars['Int']
}

export type ScheduleInput = {
  active?: InputMaybe<Scalars['Boolean']>
  actors?: InputMaybe<Array<ReferenceInput>>
  name?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  reoccuranceTemplate?: InputMaybe<ReoccuranceTemplateInput>
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  subjectLimit?: InputMaybe<Scalars['Int']>
}

export type ScheduleResponse = {
  results: Array<Schedule>
  searchAfter?: Maybe<Scalars['AWSJSON']>
  totalCount?: Maybe<Scalars['Int']>
}

export type ScheduleSummary = {
  active: Scalars['Boolean']
  id: Scalars['ID']
  locations?: Maybe<Array<LocationSummary>>
  reoccuranceTemplate: ReoccuranceTemplateSummary
  serviceCategory: ServiceCategory
  serviceType: ServiceType
}

export type SearchFilter = {
  filter: SearchFilterEnum
  operator?: InputMaybe<Operator>
  value: Scalars['String']
}

export enum SearchFilterEnum {
  ApptStatus = 'APPT_STATUS',
  CategoryCode = 'CATEGORY_CODE',
  EndDate = 'END_DATE',
  ParticipantTypeCode = 'PARTICIPANT_TYPE_CODE',
  PatientId = 'PATIENT_ID',
  ProviderId = 'PROVIDER_ID',
  StartDate = 'START_DATE',
}

export type SearchPatientsResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']>
  from?: Maybe<Scalars['Int']>
  patients: Array<SearchablePatient>
  resultCount: Scalars['Int']
  searchAfter?: Maybe<Scalars['AWSJSON']>
}

export type SearchProvider = {
  ages?: Maybe<Array<Scalars['String']>>
  availability?: Maybe<Scalars['String']>
  availabilityNotes?: Maybe<Scalars['String']>
  bio?: Maybe<Scalars['String']>
  careCoordinator?: Maybe<Reference>
  careManagerId: Scalars['ID']
  clinicalAges?: Maybe<Array<Scalars['String']>>
  clinicalModalities?: Maybe<Array<Scalars['String']>>
  clinicalSpecialties?: Maybe<Array<Scalars['String']>>
  communityIdentity?: Maybe<Array<CommunityIdentity>>
  email: Scalars['String']
  employment?: Maybe<Employment>
  ethnicity?: Maybe<Ethnicity>
  expectedHours?: Maybe<Array<ExpectedHours>>
  firstName: Scalars['String']
  genderIdentity?: Maybe<GenderIdentity>
  id: Scalars['ID']
  identifiers?: Maybe<Array<ProviderIdentifier>>
  languages?: Maybe<Array<Scalars['String']>>
  lastName: Scalars['String']
  licenses?: Maybe<Array<ProviderLicense>>
  modalities?: Maybe<Array<Scalars['String']>>
  payerEnrollments?: Maybe<Array<PayerEnrollment>>
  race?: Maybe<Array<Race>>
  schedules?: Maybe<Array<ScheduleSummary>>
  serviceTypes?: Maybe<Array<ProviderServiceType>>
  specialties?: Maybe<Array<Scalars['String']>>
  spirituality?: Maybe<Array<Scalars['String']>>
  supervisees?: Maybe<Array<Reference>>
  supervisor?: Maybe<Reference>
  teamLead?: Maybe<Reference>
}

export type SearchProvidersResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']>
  from?: Maybe<Scalars['Int']>
  resultCount: Scalars['Int']
  results: Array<SearchProvider>
  searchAfter?: Maybe<Scalars['AWSJSON']>
}

export type SearchablePatient = {
  address?: Maybe<PatientAddress>
  billingInsurances?: Maybe<Array<PatientBillingInsurance>>
  careTeam?: Maybe<Array<CareTeamSearchMember>>
  dateOfBirth?: Maybe<Scalars['AWSDate']>
  dischargeReason?: Maybe<Scalars['String']>
  emrId?: Maybe<Scalars['String']>
  gender?: Maybe<Scalars['String']>
  genderDetails?: Maybe<Scalars['String']>
  genderIdentity?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isIntegrationActive?: Maybe<Scalars['Boolean']>
  mrn?: Maybe<Scalars['String']>
  name: PatientName
  notices?: Maybe<Array<PatientNotice>>
  preferredLanguage?: Maybe<Scalars['String']>
  primaryEmail?: Maybe<Scalars['String']>
  primaryPhone?: Maybe<Scalars['String']>
  pronouns?: Maybe<Scalars['String']>
  selfPay: Scalars['Boolean']
  signInPhone?: Maybe<Scalars['String']>
  status: PatientStatus
  tags?: Maybe<Array<Scalars['String']>>
  timeZone?: Maybe<Scalars['String']>
  treatmentId: Scalars['ID']
  upcomingAppointments?: Maybe<Array<AppointmentDisplay>>
  videoRoomId?: Maybe<Scalars['String']>
}

export type SearchableReference = {
  active?: Maybe<Scalars['Boolean']>
  display?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  reference?: Maybe<Scalars['String']>
}

export type SearchableTask = {
  assignee: SearchableReference
  assigneeId: Scalars['ID']
  createdBy: SearchableReference
  createdById: Scalars['ID']
  createdDate: Scalars['AWSDateTime']
  description: Scalars['String']
  dueDate: Scalars['AWSDate']
  id: Scalars['ID']
  lastUpdatedDate: Scalars['AWSDateTime']
  patient?: Maybe<PatientMetaData>
  patientId: Scalars['ID']
  recentComments: Array<Annotation>
  referralSource?: Maybe<Scalars['String']>
  serviceType?: Maybe<TaskServiceType>
  status: TaskStatus
  treatmentId: Scalars['ID']
  type: TaskType
}

export type SecurityRoleResponse = {
  key: Scalars['String']
  name: Scalars['String']
}

export type SendConsentPacketInput = {
  /** If true sends new agreement even if fullConsentPacketSigned is true */
  checkIfAlreadySigned?: InputMaybe<Scalars['Boolean']>
  /** If there is already an agreement sent out for signature, this will cancel it and send a new, otherwise only a reminder email will be sent */
  forceNew?: InputMaybe<Scalars['Boolean']>
  treatmentId: Scalars['ID']
  /** Whether to send from the service user account or send agreement with the api callers email (person who sent the consent packet will get emails of sign events) */
  usingServiceUser?: InputMaybe<Scalars['Boolean']>
}

export type SendConsentPacketResponse = {
  code?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type SendEligibilityVerificationInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']>
  billingInsuranceType?: InputMaybe<Scalars['String']>
  eligibilityVerificationId?: InputMaybe<Scalars['ID']>
  medium: CommunicationMedium
  treatmentId: Scalars['ID']
}

export type SendOtpInput = {
  method?: InputMaybe<OtpMethod>
  phoneNumber: Scalars['String']
}

export type SendOtpResponse = {
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type ServiceCategory = ICodeableConcept & {
  code: ServiceCategoryCode
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']>
}

export enum ServiceCategoryCode {
  Admin = 'ADMIN',
  Break = 'BREAK',
  Cap = 'CAP',
  Consult = 'CONSULT',
  Group = 'GROUP',
  Intake = 'INTAKE',
  OutOfOffice = 'OUT_OF_OFFICE',
  Patient = 'PATIENT',
  Toc = 'TOC',
}

export type ServiceType = ICodeableConcept & {
  code: ServiceTypeCode
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']>
}

export enum ServiceTypeCode {
  Adm = 'ADM',
  Brk = 'BRK',
  Con = 'CON',
  Dbt = 'DBT',
  DbtInt = 'DBT_INT',
  Emdr = 'EMDR',
  EmdrInt = 'EMDR_INT',
  F30 = 'F30',
  F45 = 'F45',
  F60 = 'F60',
  Grp = 'GRP',
  GrpInt = 'GRP_INT',
  Int = 'INT',
  Int45 = 'INT45',
  LocInt = 'LOC_INT',
  Medrec = 'MEDREC',
  Other = 'OTHER',
  PsyCapInt = 'PSY_CAP_INT',
  PsyF20 = 'PSY_F20',
  PsyF30 = 'PSY_F30',
  PsyF45 = 'PSY_F45',
  PsyF60 = 'PSY_F60',
  PsyInc = 'PSY_INC',
  PsyInt = 'PSY_INT',
  PsyTocInt = 'PSY_TOC_INT',
  PsyTrf = 'PSY_TRF',
  TocInt = 'TOC_INT',
  Trf = 'TRF',
}

export enum SessionType {
  GoogleMeet = 'GOOGLE_MEET',
  InPerson = 'IN_PERSON',
  Other = 'OTHER',
  ValeraVideo = 'VALERA_VIDEO',
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type SortParam = {
  field: SearchFilterEnum
  order: SortOrder
}

export type StandardListItem = IListItem & {
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  label: Scalars['String']
  sortOrder?: Maybe<Scalars['Int']>
  value: Scalars['String']
}

export type State = {
  code?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
}

export type StateInput = {
  code: Scalars['String']
  name: Scalars['String']
}

export type SubmissionResponse = {
  message?: Maybe<Scalars['String']>
  submissionId: Scalars['ID']
  success: Scalars['Boolean']
}

export type SyncToEmrInput = {
  treatmentId: Scalars['ID']
}

export type Task = {
  _id: Scalars['ID']
  assignee: Reference
  comments?: Maybe<Array<Annotation>>
  createdBy: Reference
  createdDate: Scalars['AWSDateTime']
  description: Scalars['String']
  dueDate: Scalars['AWSDate']
  lastUpdatedDate: Scalars['AWSDateTime']
  patient?: Maybe<PatientMetaData>
  patientId: Scalars['ID']
  patientPreferences?: Maybe<Scalars['AWSJSON']>
  referralSource?: Maybe<Scalars['String']>
  serviceType?: Maybe<TaskServiceType>
  status: TaskStatus
  treatmentId: Scalars['ID']
  type: TaskType
}

export type TaskReferenceInput = {
  _id: Scalars['ID']
  type: ResourceType
}

export type TaskResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']>
  from?: Maybe<Scalars['Int']>
  resultCount: Scalars['Int']
  searchAfter?: Maybe<Scalars['AWSJSON']>
  tasks: Array<SearchableTask>
}

export enum TaskServiceType {
  GroupTherapy = 'GROUP_THERAPY',
  MedMgmt = 'MED_MGMT',
  Therapy = 'THERAPY',
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE',
  ToDo = 'TO_DO',
  Void = 'VOID',
}

export enum TaskType {
  ApptCancelation = 'APPT_CANCELATION',
  ApptRequest = 'APPT_REQUEST',
  ApptReschedule = 'APPT_RESCHEDULE',
  AttendanceAgreement = 'ATTENDANCE_AGREEMENT',
  Billing = 'BILLING',
  CaseTransfer = 'CASE_TRANSFER',
  DeaClearance = 'DEA_CLEARANCE',
  Discharge = 'DISCHARGE',
  Grievance = 'GRIEVANCE',
  InsuranceVerification = 'INSURANCE_VERIFICATION',
  MedRecordRequest = 'MED_RECORD_REQUEST',
  MissingInfo = 'MISSING_INFO',
  NewPatientCallCenter = 'NEW_PATIENT_CALL_CENTER',
  NewPatientCallReferral = 'NEW_PATIENT_CALL_REFERRAL',
  NewPatientReferral = 'NEW_PATIENT_REFERRAL',
  NewPatientSelf = 'NEW_PATIENT_SELF',
  NewPatientToc = 'NEW_PATIENT_TOC',
  NewPatientWaitlist = 'NEW_PATIENT_WAITLIST',
  Other = 'OTHER',
  PatientTransfer = 'PATIENT_TRANSFER',
  PriorAuthorization = 'PRIOR_AUTHORIZATION',
  ReferralToExternal = 'REFERRAL_TO_EXTERNAL',
  ReferralToInternal = 'REFERRAL_TO_INTERNAL',
  RefillRequest = 'REFILL_REQUEST',
  TechIssue = 'TECH_ISSUE',
  TransitionsOfCare = 'TRANSITIONS_OF_CARE',
}

export type TimeSlot = {
  dayOfWeek: DayOfWeek
  durationMinutes: Scalars['Int']
  endDate: Scalars['AWSDateTime']
  endTime: Scalars['AWSTime']
  id: Scalars['ID']
  locations?: Maybe<Array<Scalars['ID']>>
  provider: TimeSlotProvider
  scheduleId: Scalars['ID']
  serviceCategoryCode: Scalars['String']
  startDate: Scalars['AWSDateTime']
  startTime: Scalars['AWSTime']
}

export type TimeSlotLicense = {
  licenseType: LicenseType
  stateCode: Scalars['String']
}

export type TimeSlotProvider = {
  availabilityNotes?: Maybe<Scalars['String']>
  availabilityStatus: Availability
  bio?: Maybe<Scalars['String']>
  careCoordinatorId?: Maybe<Scalars['ID']>
  clinicalAges?: Maybe<Array<Scalars['String']>>
  clinicalModalities?: Maybe<Array<Scalars['String']>>
  clinicalSpecialties?: Maybe<Array<Scalars['String']>>
  communityIdentity?: Maybe<Array<CommunityIdentity>>
  ethnicity?: Maybe<Ethnicity>
  genderIdentity?: Maybe<GenderIdentity>
  id: Scalars['ID']
  insurancePlans?: Maybe<Array<Scalars['ID']>>
  languages?: Maybe<Array<Scalars['String']>>
  legalSex?: Maybe<LegalSex>
  licenses?: Maybe<Array<TimeSlotLicense>>
  name: Scalars['String']
  profession: ProfessionCode
  race?: Maybe<Array<Race>>
  serviceType?: Maybe<Array<ProviderServiceType>>
  spirituality?: Maybe<Array<Scalars['String']>>
  supervisorId?: Maybe<Scalars['ID']>
}

export type TimeSlotSearchRes = OpenSearchRes & {
  aggregations?: Maybe<Scalars['AWSJSON']>
  from?: Maybe<Scalars['Int']>
  resultCount: Scalars['Int']
  results: Array<TimeSlot>
  searchAfter?: Maybe<Scalars['AWSJSON']>
}

export type TocConfiguration = {
  fuh7: Scalars['Boolean']
  fuh30: Scalars['Boolean']
  fum7: Scalars['Boolean']
  fum30: Scalars['Boolean']
  referralSourceFilter?: Maybe<Scalars['String']>
}

export type TocConfigurationInput = {
  fuh7: Scalars['Boolean']
  fuh30: Scalars['Boolean']
  fum7: Scalars['Boolean']
  fum30: Scalars['Boolean']
  referralSourceFilter?: InputMaybe<Scalars['String']>
}

export enum TokenType {
  Bearer = 'Bearer',
}

export enum TrainingProgramType {
  Fellowship = 'FELLOWSHIP',
  Internship = 'INTERNSHIP',
  Residency = 'RESIDENCY',
}

export type UpdateAppointmentInput = {
  appointmentType?: InputMaybe<AppointmentType>
  cancelationReason?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['AWSDateTime']>
  fulfilledStatus?: InputMaybe<FulfilledAppointmentStatisticsInput>
  identifiers?: InputMaybe<Array<AppointmentIdentifierInput>>
  minutesDuration?: InputMaybe<Scalars['Float']>
  note?: InputMaybe<Scalars['String']>
  occuranceChanged?: InputMaybe<Scalars['Boolean']>
  participants?: InputMaybe<Array<ParticipantInput>>
  replacesAppointmentId?: InputMaybe<Scalars['String']>
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  startDate?: InputMaybe<Scalars['AWSDateTime']>
  status?: InputMaybe<AppointmentStatus>
  virtualService?: InputMaybe<VirtualServiceInput>
}

export type UpdateBillingExternalInput = {
  cardBack?: InputMaybe<FileCreate>
  cardFront?: InputMaybe<FileCreate>
  type: InsuranceOrdinality
}

export type UpdateBillingInput = {
  comment?: InputMaybe<CommentAnnotationInput>
  consentPacketSignedDate?: InputMaybe<Scalars['AWSDateTime']>
  creditCardOnFile?: InputMaybe<Scalars['Boolean']>
  fullConsentPackedSigned?: InputMaybe<Scalars['Boolean']>
  idFile?: InputMaybe<FileUpdate>
  idRelationship?: InputMaybe<PatientRelationshipToIdCard>
  idType?: InputMaybe<IdentificationType>
  idValue?: InputMaybe<Scalars['String']>
  insurances?: InputMaybe<Array<BillingInsuredInput>>
  selfPay?: InputMaybe<Scalars['Boolean']>
}

export type UpdateBillingInsuredInput = {
  data: BillingInsuredInput
  id: Scalars['String']
  type?: InputMaybe<Scalars['String']>
}

export type UpdateDocumentInput = {
  file: FileUpdate
  id: Scalars['ID']
}

export type UpdateListItemInput = {
  description?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  label?: InputMaybe<Scalars['String']>
  sortOrder?: InputMaybe<Scalars['Int']>
}

export type UpdatePatientBillingInput = {
  data: UpdateBillingInput
  id?: InputMaybe<Scalars['ID']>
  treatmentId?: InputMaybe<Scalars['ID']>
}

export type UpdatePatientBillingInsuredInput = {
  id?: InputMaybe<Scalars['ID']>
  insurances: Array<InputMaybe<UpdateBillingInsuredInput>>
  treatmentId?: InputMaybe<Scalars['ID']>
}

export type UpdatePatientRegistrationSubmission = {
  additionalTaskDescription?: InputMaybe<Scalars['AWSJSON']>
  address?: InputMaybe<AddressComponentsInput>
  billing?: InputMaybe<UpdateBillingInput>
  conditionInterferingWithVirtualTreatment?: InputMaybe<Scalars['Boolean']>
  contacts?: InputMaybe<Array<Contact>>
  dischargeDate?: InputMaybe<Scalars['AWSDate']>
  dischargeType?: InputMaybe<Scalars['String']>
  dob?: InputMaybe<Scalars['AWSDate']>
  documents?: InputMaybe<Array<CreateDocumentInput>>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<PatientGenderIdentity>
  genderDetails?: InputMaybe<Scalars['String']>
  hospitalized?: InputMaybe<Scalars['Boolean']>
  lastName?: InputMaybe<Scalars['String']>
  legalSex?: InputMaybe<PatientLegalSex>
  meta?: InputMaybe<Scalars['AWSJSON']>
  patientTimeZone?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  preferredContactDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  preferredContactTimes?: InputMaybe<Array<Scalars['String']>>
  preferredLanguage?: InputMaybe<Scalars['String']>
  preferredName?: InputMaybe<Scalars['String']>
  referralSource?: InputMaybe<Scalars['String']>
  referralSourceOther?: InputMaybe<Scalars['String']>
  referrer?: InputMaybe<ReferrerInformation>
  serviceType?: InputMaybe<Array<Scalars['String']>>
  specialty?: InputMaybe<Array<Scalars['String']>>
  submissionId: Scalars['String']
  taskTypeOverride?: InputMaybe<PatientOnboardingTaskType>
  tellUsMore?: InputMaybe<Scalars['String']>
  treatmentHistory?: InputMaybe<Scalars['String']>
}

export type UpdatePayerEnrollmentInput = {
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']>
  entity?: InputMaybe<Scalars['String']>
  expirationDate?: InputMaybe<Scalars['AWSDate']>
  id: Scalars['ID']
  payerExternalProviderId?: InputMaybe<Scalars['String']>
  payerId?: InputMaybe<Scalars['ID']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']>
  status?: InputMaybe<Scalars['String']>
  submissionDate?: InputMaybe<Scalars['AWSDate']>
  terminationDate?: InputMaybe<Scalars['AWSDate']>
  vendor?: InputMaybe<Scalars['String']>
}

export type UpdateProviderDocumentInput = {
  documentCategory?: InputMaybe<DocumentCategory>
  file?: InputMaybe<FileUpdate>
  id: Scalars['ID']
  stateCode?: InputMaybe<Scalars['String']>
  status?: InputMaybe<DocumentVerificationStatus>
}

export type UpdateReoccuranceTemplateResponse = {
  reoccuranceTemplate: ReoccuranceTemplate
  warnings: Array<AppointmentWarning>
}

export type UpdateTaskInputV2 = {
  assignee?: InputMaybe<Scalars['ID']>
  comment?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['AWSDate']>
  id: Scalars['ID']
  patientPreferences?: InputMaybe<Scalars['AWSJSON']>
  referralSource?: InputMaybe<Scalars['String']>
  serviceType?: InputMaybe<TaskServiceType>
  status?: InputMaybe<TaskStatus>
  type?: InputMaybe<TaskType>
}

export type User = {
  careManager: CareManagerUser
  cognito?: Maybe<Cognito>
  permitRoles?: Maybe<Array<Scalars['ID']>>
}

export type UserSignUpInput = {
  careManagerPermissions?: InputMaybe<CareManagerPermissionsInput>
  email: Scalars['String']
  emrId?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  isProvider?: InputMaybe<Scalars['Boolean']>
  lastName: Scalars['String']
  permitRoles: Array<Scalars['ID']>
  phone?: InputMaybe<Scalars['String']>
  preferredName?: InputMaybe<Scalars['String']>
  pronouns?: InputMaybe<Scalars['String']>
}

export type UserSummary = {
  careManagerId?: Maybe<Scalars['String']>
  cognitoUserId?: Maybe<Scalars['String']>
  display: UserSummaryDisplayNames
  email?: Maybe<Scalars['String']>
  emrId?: Maybe<Scalars['String']>
  isEnabled?: Maybe<Scalars['Boolean']>
  picture?: Maybe<Scalars['String']>
  providerId?: Maybe<Scalars['String']>
  publicRole?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type UserSummaryDisplayNames = {
  expandedName?: Maybe<Scalars['String']>
  fullName?: Maybe<Scalars['String']>
  legalName?: Maybe<Scalars['String']>
  legalQualifiedName?: Maybe<Scalars['String']>
  publicName?: Maybe<Scalars['String']>
  qualifiedName?: Maybe<Scalars['String']>
}

export type UserUpdateInput = {
  careManagerPermissions?: InputMaybe<CareManagerPermissionsInput>
  email?: InputMaybe<Scalars['String']>
  emrId?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  isProvider?: InputMaybe<Scalars['Boolean']>
  lastName?: InputMaybe<Scalars['String']>
  permitRoles?: InputMaybe<Array<Scalars['ID']>>
  phone?: InputMaybe<Scalars['String']>
  preferredName?: InputMaybe<Scalars['String']>
  pronouns?: InputMaybe<Scalars['String']>
}

export type ValidateCaptchaAndMatchInput = {
  captchaToken: Scalars['String']
  dateOfBirth: Scalars['AWSDate']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber: Scalars['String']
  publicCode?: InputMaybe<Scalars['String']>
}

export type ValidateCaptchaInput = {
  captchaToken: Scalars['String']
  dateOfBirth: Scalars['AWSDate']
  firstName: Scalars['String']
  lastName: Scalars['String']
  phoneNumber: Scalars['String']
  publicCode?: InputMaybe<Scalars['String']>
}

export type ValidateOtpInput = {
  dateOfBirth: Scalars['AWSDate']
  firstName: Scalars['String']
  lastName: Scalars['String']
  otpToken: Scalars['String']
  phoneNumber: Scalars['String']
  publicCode?: InputMaybe<Scalars['String']>
}

export enum VerificationVendor {
  PVerify = 'pVerify',
}

export type VerifyEligibilityInput = {
  billingInsuranceId: Scalars['String']
  insured: EligibilityInsuredInput
  location?: InputMaybe<Scalars['String']>
  patient?: InputMaybe<EligibilityPatientInput>
  payerId: Scalars['String']
  providerName: Scalars['String']
  providerNpi: Scalars['String']
  treatmentId: Scalars['String']
}

export type VirtualService = {
  addressUrl?: Maybe<Scalars['String']>
  channelType: SessionType
  phoneNumber?: Maybe<Scalars['String']>
  sessionKey?: Maybe<Scalars['String']>
}

export type VirtualServiceInput = {
  addressUrl?: InputMaybe<Scalars['String']>
  channelType: Scalars['String']
  phoneNumber?: InputMaybe<Scalars['String']>
  sessionKey?: InputMaybe<Scalars['String']>
}

export enum WeekOfMonth {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD',
}

export type WeeklyTemplate = PatternTemplate & {
  dayTimes: Array<DayTime>
  interval: Scalars['Int']
  offset: Scalars['Int']
}

export type WeeklyTemplateInput = {
  dayTimes: Array<DayTimeInput>
  interval: Scalars['Int']
  offset: Scalars['Int']
}

export type FulfilledAppointmentStatistics = {
  endDate: Scalars['AWSDateTime']
  minutesDuration: Scalars['Float']
  startDate: Scalars['AWSDateTime']
}

export type FulfilledAppointmentStatisticsInput = {
  endDate: Scalars['AWSDateTime']
  minutesDuration: Scalars['Float']
  startDate: Scalars['AWSDateTime']
}

export type OutOfNetworkPlan = {
  name?: Maybe<Scalars['String']>
  state?: Maybe<State>
}

export type TimeSlotProviderFrag = {
  id: string
  name: string
  serviceType?: Array<ProviderServiceType> | null
  availabilityStatus: Availability
  availabilityNotes?: string | null
  insurancePlans?: Array<string> | null
  careCoordinatorId?: string | null
  supervisorId?: string | null
  genderIdentity?: GenderIdentity | null
  race?: Array<Race> | null
  ethnicity?: Ethnicity | null
  languages?: Array<string> | null
  spirituality?: Array<string> | null
  communityIdentity?: Array<CommunityIdentity> | null
  clinicalAges?: Array<string> | null
  clinicalModalities?: Array<string> | null
  clinicalSpecialties?: Array<string> | null
  bio?: string | null
  legalSex?: LegalSex | null
  profession: ProfessionCode
  licenses?: Array<{ licenseType: LicenseType; stateCode: string }> | null
}

export type TimeSlotFrag = {
  id: string
  scheduleId: string
  startDate: string
  endDate: string
  startTime: string
  endTime: string
  dayOfWeek: DayOfWeek
  durationMinutes: number
  serviceCategoryCode: string
  locations?: Array<string> | null
  provider: TimeSlotProviderFrag
}

export type TimeSlotSearchResFrag = {
  resultCount: number
  from?: number | null
  searchAfter?: string | null
  aggregations?: string | null
  results: Array<TimeSlotFrag>
}

export type TimeSlotSearchVariables = Exact<{
  query: Scalars['AWSJSON']
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  sort?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['Int']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
}>

export type TimeSlotSearch = { timeSlotSearch: TimeSlotSearchResFrag }

export type StandardListItemFrag = {
  id: string
  value: string
  label: string
  description?: string | null
}

export type ListResponseFrag = {
  key: string
  list?: Array<StandardListItemFrag> | null
}

export type ProgramSettingsFrag = {
  flags?: { isWellness: boolean } | null
  appointmentSettings?: {
    flags?: { useSchedulingAppt?: boolean | null } | null
  } | null
}

export type AppendListItemsVariables = Exact<{
  key: Scalars['String']
  input: Array<AppendListItemInput>
}>

export type AppendListItems = { appendListItems: Array<StandardListItemFrag> }

export type UpdateListItemsVariables = Exact<{
  key: Scalars['String']
  input: Array<UpdateListItemInput>
}>

export type UpdateListItems = { updateListItems: Array<StandardListItemFrag> }

export type DeleteListItemsVariables = Exact<{
  key: Scalars['String']
  input: Array<Scalars['ID']>
}>

export type DeleteListItems = { deleteListItems: Array<StandardListItemFrag> }

export type GetListVariables = Exact<{
  keys: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}>

export type GetList = { getList: Array<ListResponseFrag> }

export type GetProgramSettingsVariables = Exact<{
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}>

export type GetProgramSettings = { getProgramSettings: ProgramSettingsFrag }

export type AuditEntryFragment = {
  date: string
  reference: { id?: string | null; type: ResourceType; display?: string | null }
}

export type FileFragment = { mimeType: string; name: string; url: string }

export type EmploymentFragment = {
  _id: string
  type?: EmploymentType | null
  status?: EmploymentStatus | null
  title?: string | null
  role?: EmploymentRole | null
  hireDate?: string | null
  startDate?: string | null
  terminationDate?: string | null
  profession?: ProfessionCode | null
  legalSex?: LegalSex | null
  stateOfResidence?: string | null
}

export type ProviderIdentifierFragment = {
  id: string
  type: ProviderIdentifierType
  value: string
  effectiveDate?: string | null
  expirationDate?: string | null
}

export type PractMgrReferenceFragment = {
  id?: string | null
  display?: string | null
}

export type ExpectedHoursFragment = {
  weeklyMinutesTotal: number
  startDate?: string | null
  endDate?: string | null
  serviceCategory: { code: ServiceCategoryCode }
}

export type PayerSummaryFrag = {
  id: string
  name: string
  stateCode: string
  status: PayerStatus
}

export type MatchedTokenResponseFragment = {
  access_token: string
  id_token: string
  token_type: TokenType
  expires_in: number
}

export type ExternalResponseFragment = {
  success: boolean
  message?: string | null
}

export type ValidateCaptchaAndMatchVariables = Exact<{
  input: ValidateCaptchaAndMatchInput
}>

export type ValidateCaptchaAndMatch = {
  validateCaptchaAndMatch?: MatchedTokenResponseFragment | null
}

export type SendOtpVariables = Exact<{
  input: SendOtpInput
}>

export type SendOtp = { sendOTP?: ExternalResponseFragment | null }

export type ConfirmOtpAndMatchVariables = Exact<{
  input: ConfirmOtpAndMatchInput
}>

export type ConfirmOtpAndMatch = {
  confirmOTPAndMatch?: MatchedTokenResponseFragment | null
}

export type TokenResponse = { access_token: string; expires_in: number }

export type SavePatientBillingExternalVariables = Exact<{
  input: SavePatientBillingExternalInput
}>

export type SavePatientBillingExternal = {
  savePatientBillingExternal: { success: boolean }
}

export type CreatePatientSubmissionVariables = Exact<{
  input: CreatePatientRegistrationSubmission
}>

export type CreatePatientSubmission = {
  createPatientRegistrationSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
  }
}

export type UpdatePatientSubmissionVariables = Exact<{
  input: UpdatePatientRegistrationSubmission
}>

export type UpdatePatientSubmission = {
  updatePatientRegistrationSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
  }
}

export type CompletePatientSubmissionVariables = Exact<{
  input: CompletePatientRegistrationSubmission
}>

export type CompletePatientSubmission = {
  completePatientRegistrationSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
  }
}

export type GetExternalLanguagesVariables = Exact<{ [key: string]: never }>

export type GetExternalLanguages = {
  getExternalLanguages: Array<{ code?: string | null; display: string }>
}

export type GetExternalInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetExternalInsurancePlans = {
  getExternalInsurancePlans: Array<{
    _id: string
    name: string
    stateCode?: string | null
    payerId?: string | null
    payerName?: string | null
    verificationPayerId?: string | null
    verificationPayerName?: string | null
    tocConfiguration?: Array<{
      referralSourceFilter?: string | null
      fuh7: boolean
      fuh30: boolean
      fum7: boolean
      fum30: boolean
    }> | null
  }>
}

export type GetExternalPracticeStatesVariables = Exact<{
  programCode?: InputMaybe<Scalars['String']>
}>

export type GetExternalPracticeStates = {
  getExternalPracticeStates: Array<{
    stateCode: string
    availabilityStatus: PracticeStateAvailabilityStatus
  }>
}

export type CheckEligibilityFragment = {
  id: string
  isActive?: boolean | null
  benefitSummaryPdfFile?: string | null
  generatingBenefitSummaryPdfFile?: boolean | null
  billingInsuranceId?: string | null
  ts?: string | null
  insurancePlanId?: string | null
  requestId?: number | null
  actionLog: Array<ActionEntryFragment>
}

export type ConsentPacketInfoFragment = {
  signedDate?: string | null
  agreementId?: string | null
  sent?: AuditEntryFragment | null
}

export type BillingFullFragment = {
  id: string
  treatmentId: string
  patientId: string
  idRelationship?: PatientRelationshipToIdCard | null
  idType?: IdentificationType | null
  idValue?: string | null
  fullConsentPackedSigned?: boolean | null
  creditCardOnFile?: boolean | null
  selfPay?: boolean | null
  hasBillableAppointment?: boolean | null
  idFile?: FileFragment | null
  consentPacketInfo?: ConsentPacketInfoFragment | null
  insurances?: Array<BillingInsuredFragment> | null
  emrSyncStatistics?: {
    emrSyncStatus: EmrSyncStatusCode
    lastSynced?: AuditEntryFragment | null
  } | null
  comments?: Array<{
    time: string
    text: string
    authorReference: { id?: string | null; display?: string | null }
  }> | null
}

export type BillingInsuredFragment = {
  id?: string | null
  type?: InsuranceOrdinality | null
  eligibilityVerified?: boolean | null
  eligibilityReason?: string | null
  relationship?: PatientRelationshipToInsured | null
  firstName?: string | null
  lastName?: string | null
  middleInitial?: string | null
  dateOfBirth?: string | null
  legalSex?: PatientLegalSex | null
  phone?: string | null
  insurancePlanId?: string | null
  outOfNetwork?: boolean | null
  note?: string | null
  idNumber?: string | null
  policyGroupFecaNumber?: string | null
  policyGroupName?: string | null
  effectiveDate?: string | null
  expirationDate?: string | null
  coPay?: string | null
  medicaidIdNumber?: string | null
  medicareIdNumber?: string | null
  emrSyncStatus?: EmrSyncStatusCode | null
  priorAuthRequired?: PriorAuthStatus | null
  payerPlanName?: string | null
  payerPlanType?: string | null
  deductible?: number | null
  familyDeductible?: number | null
  coinsurance?: number | null
  addressComponents?: {
    street?: string | null
    city?: string | null
    state?: string | null
    zipcode?: string | null
  } | null
  outOfNetworkPlan?: {
    name?: string | null
    state?: { code?: string | null; name?: string | null } | null
  } | null
  cardFront?: FileFragment | null
  cardBack?: FileFragment | null
  medicaidCard?: FileFragment | null
  medicareCard?: FileFragment | null
}

export type DocumentFragment = {
  id: string
  file: FileFragment
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
}

export type PatientIntegrationFragment = {
  emrId?: string | null
  isActive: boolean
}

export type PatientFragment = {
  integration?: PatientIntegrationFragment | null
}

export type ActionEntryFragment = {
  code: ActionEntryCode
  description: string
  author: AuditEntryFragment
}

export type VerifyEligibilityVariables = Exact<{
  input: VerifyEligibilityInput
}>

export type VerifyEligibility = { verifyEligibility: CheckEligibilityFragment }

export type SavePatientBillingVariables = Exact<{
  input: UpdatePatientBillingInput
}>

export type SavePatientBilling = {
  savePatientBilling?: BillingFullFragment | null
}

export type GeneratePatientLinkVariables = Exact<{
  input: GeneratePatientLinkInput
}>

export type GeneratePatientLink = {
  generatePatientLink: { shortLink: string; fullLink: string }
}

export type AppendDocumentsVariables = Exact<{
  treatmentId: Scalars['ID']
  content: Array<CreateDocumentInput>
}>

export type AppendDocuments = { appendDocuments: Array<DocumentFragment> }

export type UpdateDocumentsVariables = Exact<{
  treatmentId: Scalars['ID']
  content: Array<UpdateDocumentInput>
}>

export type UpdateDocuments = { updateDocuments: Array<DocumentFragment> }

export type RemoveDocumentsVariables = Exact<{
  treatmentId: Scalars['ID']
  documentIds: Array<Scalars['ID']>
}>

export type RemoveDocuments = { removeDocuments: Array<DocumentFragment> }

export type SendConsentPacketVariables = Exact<{
  treatmentId: Scalars['ID']
}>

export type SendConsentPacket = {
  sendConsentPacket: {
    success: boolean
    code?: string | null
    message?: string | null
  }
}

export type SyncToEmrVariables = Exact<{
  input: SyncToEmrInput
}>

export type SyncToEmr = {
  syncToEmr: {
    emrSyncStatus: EmrSyncStatusCode
    lastSynced?: AuditEntryFragment | null
  }
}

export type UpdatePatientIntegrationVariables = Exact<{
  treatmentId: Scalars['ID']
  content: PatientIntegrationInput
}>

export type UpdatePatientIntegration = {
  updatePatientIntegration: PatientIntegrationFragment
}

export type SendEligibilityVerificationVariables = Exact<{
  input: SendEligibilityVerificationInput
}>

export type SendEligibilityVerification = {
  sendEligibilityVerification: ActionEntryFragment
}

export type LoadPatientBillingVariables = Exact<{
  input: LoadPatientBillingInput
}>

export type LoadPatientBilling = {
  loadPatientBilling?: BillingFullFragment | null
}

export type LoadEligibilityVerificationVariables = Exact<{
  input: LoadEligibilityVerificationInput
}>

export type LoadEligibilityVerification = {
  loadEligibilityVerification?: CheckEligibilityFragment | null
}

export type GetDocumentVariables = Exact<{
  treatmentId: Scalars['ID']
  documentId: Scalars['ID']
}>

export type GetDocument = { getDocument: DocumentFragment }

export type GetDocumentsByTreatmentIdVariables = Exact<{
  treatmentId: Scalars['ID']
}>

export type GetDocumentsByTreatmentId = {
  getDocumentsByTreatmentId: Array<DocumentFragment>
}

export type GetPatientByTreatmentIdVariables = Exact<{
  treatmentId: Scalars['ID']
}>

export type GetPatientByTreatmentId = {
  getPatientByTreatmentId: PatientFragment
}

export type ListEligibilityVerificationsVariables = Exact<{
  input: ListEligibilityVerificationInput
}>

export type ListEligibilityVerifications = {
  listEligibilityVerifications: Array<CheckEligibilityFragment>
}

export type ListPatientEligibilityVerificationsVariables = Exact<{
  input: ListPatientEligibilityVerificationInput
}>

export type ListPatientEligibilityVerifications = {
  listPatientEligibilityVerifications: Array<CheckEligibilityFragment>
}

export type PatientAddressFrag = {
  street?: string | null
  city?: string | null
  state?: string | null
  zipcode?: string | null
}

export type PatientNameFrag = {
  firstName: string
  middleName?: string | null
  lastName: string
  preferredName?: string | null
  fullName: string
}

export type AppointmentDisplayFrag = {
  startDateTime: string
  endDateTime: string
  type?: string | null
  careManagerId?: string | null
  careManagerDisplay?: string | null
}

export type PatientSummaryDisplayNamesFrag = {
  fullName?: string | null
  legalName?: string | null
  expandedName?: string | null
}

export type PatientSummaryFrag = {
  patientId: string
  userId: string
  treatmentId: string
  status: PatientStatus
  email?: string | null
  phoneNumber?: string | null
  display: PatientSummaryDisplayNamesFrag
}

export type SearchablePatientFrag = {
  id: string
  treatmentId: string
  mrn?: string | null
  emrId?: string | null
  isIntegrationActive?: boolean | null
  status: PatientStatus
  dischargeReason?: string | null
  dateOfBirth?: string | null
  primaryPhone?: string | null
  primaryEmail?: string | null
  signInPhone?: string | null
  gender?: string | null
  genderIdentity?: string | null
  genderDetails?: string | null
  preferredLanguage?: string | null
  pronouns?: string | null
  timeZone?: string | null
  tags?: Array<string> | null
  videoRoomId?: string | null
  selfPay: boolean
  name: PatientNameFrag
  upcomingAppointments?: Array<AppointmentDisplayFrag> | null
  careTeam?: Array<{
    careManagerId: string
    display?: string | null
    isPrimary: boolean
  }> | null
  address?: PatientAddressFrag | null
  notices?: Array<{
    label: string
    level: NoticeLevel
    code: NoticeCode
    at?: string | null
  }> | null
  billingInsurances?: Array<SearchablePatientInsuranceFrag> | null
}

export type MinimalCareTeamSearchMemberFrag = {
  careManagerId: string
  isPrimary: boolean
}

export type MinimalSearchablePatientFrag = {
  id: string
  treatmentId: string
  emrId?: string | null
  mrn?: string | null
  status: PatientStatus
  timeZone?: string | null
  videoRoomId?: string | null
  dateOfBirth?: string | null
  primaryPhone?: string | null
  primaryEmail?: string | null
  name: { fullName: string }
  address?: { state?: string | null } | null
  notices?: Array<{
    label: string
    level: NoticeLevel
    code: NoticeCode
    at?: string | null
  }> | null
  careTeam?: Array<{ careManagerId: string; isPrimary: boolean }> | null
}

export type SearchPatientsResponseFrag = {
  resultCount: number
  from?: number | null
  searchAfter?: string | null
  aggregations?: string | null
  patients: Array<SearchablePatientFrag>
}

export type SearchablePatientInsuranceFrag = {
  type: InsuranceOrdinality
  insurancePlanId?: string | null
  outOfNetwork?: boolean | null
  outOfNetworkPlan?: {
    name?: string | null
    state?: { code?: string | null } | null
  } | null
}

export type SearchPatientsVariables = Exact<{
  query: Scalars['AWSJSON']
  sort?: InputMaybe<Scalars['AWSJSON']>
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['Int']>
}>

export type SearchPatients = { searchPatients: SearchPatientsResponseFrag }

export type GetAggregatesVariables = Exact<{
  aggregations: Scalars['AWSJSON']
}>

export type GetAggregates = { searchPatients: { aggregations?: string | null } }

export type PatientTypeAheadVariables = Exact<{
  query: Scalars['AWSJSON']
  sort?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
}>

export type PatientTypeAhead = {
  searchPatients: {
    resultCount: number
    patients: Array<MinimalSearchablePatientFrag>
  }
}

export type SearchPatientByTreatmentIdVariables = Exact<{
  query: Scalars['AWSJSON']
}>

export type SearchPatientByTreatmentId = {
  searchPatients: { patients: Array<MinimalSearchablePatientFrag> }
}

export type DescribePatientsByIdVariables = Exact<{
  patientIds: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}>

export type DescribePatientsById = {
  describePatientsById: Array<PatientSummaryFrag>
}

export type DescribePatientsByUserIdVariables = Exact<{
  userIds: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}>

export type DescribePatientsByUserId = {
  describePatientsByUserId: Array<PatientSummaryFrag>
}

export type DescribePatientsByTreatmentIdVariables = Exact<{
  treatmentIds: Array<Scalars['String']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']>
}>

export type DescribePatientsByTreatmentId = {
  describePatientsByTreatmentId: Array<PatientSummaryFrag>
}

export type CodeableConceptFragment = {
  code?: string | null
  text?: string | null
  coding?: Array<{
    system?: string | null
    code: string
    display?: string | null
  }> | null
}

export type PracticeMgrAnnotationFragment = {
  time: string
  text: string
  authorReference: PractMgrReferenceFragment
}

export type TocConfigurationFragment = {
  referralSourceFilter?: string | null
  fuh7: boolean
  fuh30: boolean
  fum7: boolean
  fum30: boolean
}

export type InsurancePlanFullFragment = {
  _id: string
  payerCode?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
  status: InsurancePlanStatus
  isInNetwork: boolean
  inNetworkBenefitTerms?: string | null
  outOfNetworkBenefitTerms?: string | null
  payerId?: string | null
  entityName?: string | null
  taxId?: string | null
  groupNpi?: string | null
  payerName?: string | null
  vendorName?: string | null
  notes?: string | null
  lineOfBusiness?: InsurancePlanLineOfBusiness | null
  verificationPayerId?: string | null
  verificationPayerName?: string | null
  verificationDefaultProviderName?: string | null
  verificationDefaultProviderNpi?: string | null
  verificationDefaultLocation?: string | null
  groupId?: string | null
  planId?: string | null
  planType?: string | null
  effectiveDate?: string | null
  recredentialingDate?: string | null
  expirationDate?: string | null
  isDelegated: boolean
  delegatedEffectiveDate?: string | null
  delegatedAuditDate?: string | null
  billingPayerName?: string | null
  credentialingPayerId?: string | null
  credentialingPayerName?: string | null
  isInheritanceDisabled?: boolean | null
  comments?: Array<PracticeMgrAnnotationFragment> | null
  tocConfiguration?: Array<TocConfigurationFragment> | null
}

export type VerificationInsurancePlanFragment = {
  _id: string
  payerCode?: string | null
  payerName?: string | null
  payerId?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
  isInNetwork: boolean
  inNetworkBenefitTerms?: string | null
  outOfNetworkBenefitTerms?: string | null
  lineOfBusiness?: InsurancePlanLineOfBusiness | null
  verificationPayerId?: string | null
  verificationDefaultProviderName?: string | null
  verificationDefaultProviderNpi?: string | null
  verificationDefaultLocation?: string | null
  planType?: string | null
  billingPayerName?: string | null
  isInheritanceDisabled?: boolean | null
}

export type FullInsurancePlanPartialFragment = {
  _id: string
  payerCode?: string | null
  name?: string | null
  stateName?: string | null
  stateCode?: string | null
  status?: InsurancePlanStatus | null
  isInheritanceDisabled?: boolean | null
}

export type FullInsurancePlanParticipantFragment = {
  _id: string
  effectiveDate?: string | null
  terminationDate?: string | null
  status?: InsurancePlanParticipantStatus | null
  insurancePlan: FullInsurancePlanPartialFragment
  billingRelationship: {
    type: BillingRelationshipType
    reference?: PractMgrReferenceFragment | null
  }
  comments?: Array<AttachmentAnnotationFragment> | null
}

export type MinimalInsurancePlanParticipantFragment = {
  insurancePlan: {
    _id: string
    name?: string | null
    stateCode?: string | null
    status?: InsurancePlanStatus | null
  }
  billingRelationship: { reference?: { display?: string | null } | null }
}

export type BaseProviderFragment = {
  _id: string
  careManagerId?: string | null
  status: ProviderStatus
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  genderIdentity?: GenderIdentity | null
  communityIdentity?: Array<CommunityIdentity> | null
  race?: Array<Race> | null
  ethnicity?: Ethnicity | null
  languages?: Array<string> | null
  spirituality?: Array<string> | null
  ages?: Array<string> | null
  modalities?: Array<string> | null
  specialties?: Array<string> | null
  bio?: string | null
  clinicalAges?: Array<string> | null
  clinicalModalities?: Array<string> | null
  clinicalSpecialties?: Array<string> | null
  availability: Availability
  availabilityNotes?: string | null
  serviceTypes?: Array<ProviderServiceType> | null
  expectedHours?: Array<ExpectedHoursFragment> | null
  supervisor?: PractMgrReferenceFragment | null
  supervisees?: Array<PractMgrReferenceFragment> | null
  careCoordinator?: PractMgrReferenceFragment | null
  teamLead?: PractMgrReferenceFragment | null
  employment?: EmploymentFragment | null
  identifiers?: Array<ProviderIdentifierFragment> | null
}

export type ProviderMinimalFragment = {
  _id: string
  careManagerId?: string | null
  firstName?: string | null
  lastName?: string | null
  status: ProviderStatus
  availability: Availability
  display?: { expandedName?: string | null; legalName?: string | null } | null
  employment?: {
    _id: string
    profession?: ProfessionCode | null
    role?: EmploymentRole | null
    status?: EmploymentStatus | null
  } | null
  licenses?: Array<MinimalProviderLicenseFragment> | null
}

export type ProviderFragment = {
  insurancePlans?: Array<FullInsurancePlanParticipantFragment> | null
  licenses?: Array<ProviderLicenseFragment> | null
  display?: UserSummaryDisplayNamesFragment | null
} & BaseProviderFragment

export type SearchInsurancePlanFragment = {
  _id: string
  payerCode?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
}

export type AllInsurancePlansMinimalFragment = {
  _id: string
  name: string
  stateCode?: string | null
  status: InsurancePlanStatus
  isInNetwork: boolean
}

export type SearchProviderFragment = {
  sort?: string | null
  insurancePlans?: Array<MinimalInsurancePlanParticipantFragment> | null
  licenses?: Array<MinimalProviderLicenseFragment> | null
} & BaseProviderFragment

export type MinimalProviderLicenseFragment = {
  licenseType: LicenseType
  stateCode: string
  status: ActiveStatus
}

export type ProviderLicenseFragment = {
  id: string
  licenseType: LicenseType
  stateCode: string
  status: ActiveStatus
  number: string
  durationType?: LicenseDurationType | null
  issueDate?: string | null
  expirationDate?: string | null
  excludeFromPayerEnrollment: boolean
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
}

export type ProviderLicenseRequestFragment = {
  id: string
  licenseType: LicenseType
  stateCode: string
  status: LicenseRequestStatus
  durationType?: LicenseDurationType | null
  requestType: LicenseRequestType
  submitDate?: string | null
  psvSubmitDate?: string | null
  completeDate?: string | null
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
  comments?: Array<PracticeMgrAnnotationFragment> | null
}

export type AddressFragment = {
  text?: string | null
  line: Array<string>
  city: string
  state: string
  postalCode: string
  countryCode?: string | null
}

export type InternationalAddressFragment = {
  line?: Array<string | null> | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  countryCode?: string | null
}

export type IdentifierFragment = {
  value: string
  type: CodeableConceptFragment
  period?: { startDate?: string | null; endDate?: string | null } | null
}

export type LocationFragment = {
  id: string
  name: string
  physicalType: CodeableConceptFragment
  address: { state: string }
}

export type ProviderDocumentFragment = {
  id: string
  documentCategory: DocumentCategory
  stateCode?: string | null
  status?: DocumentVerificationStatus | null
  file: FileFragment
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
  statusUpdated?: AuditEntryFragment | null
}

export type UserSummaryDisplayNamesFragment = {
  fullName?: string | null
  qualifiedName?: string | null
  legalName?: string | null
  legalQualifiedName?: string | null
  expandedName?: string | null
  publicName?: string | null
}

export type PayerEnrollmentFragment = {
  id: string
  status: PayerEnrollmentStatus
  vendor?: string | null
  payerExternalProviderId?: string | null
  submissionDate?: string | null
  effectiveDate?: string | null
  recredentialingDate?: string | null
  expirationDate?: string | null
  terminationDate?: string | null
  payer: PayerSummaryFrag
  comments?: Array<AttachmentAnnotationFragment> | null
  created: AuditEntryFragment
  updated?: AuditEntryFragment | null
}

export type PayerFragment = {
  id: string
  name: string
  stateCode: string
  status: PayerStatus
  note?: string | null
  comments?: Array<PracticeMgrAnnotationFragment> | null
}

export type AttachmentAnnotationFragment = {
  time: string
  text: string
  authorReference: PractMgrReferenceFragment
  attachments?: Array<FileFragment> | null
}

export type ProfessionalHistoryFragment = {
  id: string
  category: ProfessionCategory
  programType?: string | null
  institutionName?: string | null
  degree?: string | null
  startDate?: string | null
  endDate?: string | null
  completed?: boolean | null
  notes?: string | null
  organizationName?: string | null
  certificationNumber?: string | null
  recertificationDate?: string | null
  examType?: string | null
  examDate?: string | null
  numberOfAttempts?: number | null
  specialty?: string | null
  title?: string | null
  address?: InternationalAddressFragment | null
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
}

export type EncryptedValueFragment = {
  display?: string | null
  cipherText: string
  algorithm: string
}

export type ProviderCredentialingFragment = {
  firstName?: string | null
  middleName?: string | null
  lastName?: string | null
  suffix?: string | null
  priorLastName?: string | null
  dateOfBirth?: string | null
  birthCountry?: string | null
  isUSCitizen?: boolean | null
  personalEmail?: string | null
  primaryPhone?: string | null
  address?: InternationalAddressFragment | null
  ssn?: EncryptedValueFragment | null
}

export type ProviderExternalAccountFragment = {
  id: string
  type: string
  username: string
  note?: string | null
  password?: EncryptedValueFragment | null
}

export type PracticeStateFragment = {
  id: string
  stateCode: string
  entityName: string
  taxId: string
  groupNpi: string
  qualifyingPayerLicenseTypes: Array<LicenseType>
}

export type UpdateProviderVariables = Exact<{
  id: Scalars['ID']
  content: ProviderInputUpdate
}>

export type UpdateProvider = { updateProvider: ProviderFragment }

export type AppendInsurancePlanParticipantsVariables = Exact<{
  providerId: Scalars['ID']
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
}>

export type AppendInsurancePlanParticipants = {
  appendInsurancePlanParticipants: Array<{
    _id: string
    effectiveDate?: string | null
    terminationDate?: string | null
    status?: InsurancePlanParticipantStatus | null
    insurancePlan: {
      _id: string
      payerCode?: string | null
      name?: string | null
      stateName?: string | null
      stateCode?: string | null
      status?: InsurancePlanStatus | null
    }
    billingRelationship: {
      type: BillingRelationshipType
      reference?: {
        id?: string | null
        type: ResourceType
        display?: string | null
        reference?: string | null
      } | null
    }
  }>
}

export type UpdateInsurancePlanParticipantVariables = Exact<{
  providerId: Scalars['ID']
  content: InsurancePlanParticipantInput
}>

export type UpdateInsurancePlanParticipant = {
  updateInsurancePlanParticipant: {
    _id: string
    effectiveDate?: string | null
    terminationDate?: string | null
    status?: InsurancePlanParticipantStatus | null
    insurancePlan: {
      _id: string
      payerCode?: string | null
      name?: string | null
      stateName?: string | null
      stateCode?: string | null
      status?: InsurancePlanStatus | null
    }
    billingRelationship: {
      type: BillingRelationshipType
      reference?: {
        id?: string | null
        type: ResourceType
        display?: string | null
        reference?: string | null
      } | null
    }
  }
}

export type RemoveInsurancePlanParticipantsVariables = Exact<{
  providerId: Scalars['ID']
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
}>

export type RemoveInsurancePlanParticipants = {
  removeInsurancePlanParticipants: Array<{
    _id: string
    effectiveDate?: string | null
    terminationDate?: string | null
    status?: InsurancePlanParticipantStatus | null
    insurancePlan: {
      _id: string
      payerCode?: string | null
      name?: string | null
      stateName?: string | null
      stateCode?: string | null
      status?: InsurancePlanStatus | null
    }
    billingRelationship: {
      type: BillingRelationshipType
      reference?: {
        id?: string | null
        type: ResourceType
        display?: string | null
        reference?: string | null
      } | null
    }
  }>
}

export type CreateInsurancePlanVariables = Exact<{
  content: InsurancePlanCreateInput
}>

export type CreateInsurancePlan = {
  createInsurancePlan: InsurancePlanFullFragment
}

export type UpdateInsurancePlanVariables = Exact<{
  id: Scalars['ID']
  content: InsurancePlanUpdateInput
}>

export type UpdateInsurancePlan = {
  updateInsurancePlan: InsurancePlanFullFragment
}

export type DeleteInsurancePlanVariables = Exact<{
  id: Scalars['ID']
}>

export type DeleteInsurancePlan = {
  deleteInsurancePlan: InsurancePlanFullFragment
}

export type AppendProviderLicensesVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProviderLicenseCreateInput>
}>

export type AppendProviderLicenses = {
  appendProviderLicenses: Array<ProviderLicenseFragment>
}

export type UpdateProviderLicensesVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProviderLicenseUpdateInput>
}>

export type UpdateProviderLicenses = {
  updateProviderLicenses: Array<ProviderLicenseFragment>
}

export type RemoveProviderLicensesVariables = Exact<{
  providerId: Scalars['ID']
  licenseIds: Array<Scalars['ID']>
}>

export type RemoveProviderLicenses = {
  removeProviderLicenses: Array<ProviderLicenseFragment>
}

export type AddProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProviderLicenseRequestCreateInput>
}>

export type AddProviderLicenseRequests = {
  addProviderLicenseRequests: Array<ProviderLicenseRequestFragment>
}

export type UpdateProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProviderLicenseRequestUpdateInput>
}>

export type UpdateProviderLicenseRequests = {
  updateProviderLicenseRequests: Array<ProviderLicenseRequestFragment>
}

export type RemoveProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']
  licenseIds: Array<Scalars['ID']>
}>

export type RemoveProviderLicenseRequests = {
  removeProviderLicenseRequests: Array<ProviderLicenseRequestFragment>
}

export type AppendProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<CreateProviderDocumentInput>
}>

export type AppendProviderDocuments = {
  appendProviderDocuments: Array<ProviderDocumentFragment>
}

export type UpdateProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<UpdateProviderDocumentInput>
}>

export type UpdateProviderDocuments = {
  updateProviderDocuments: Array<ProviderDocumentFragment>
}

export type RemoveProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']
  documentIds: Array<Scalars['ID']>
}>

export type RemoveProviderDocuments = {
  removeProviderDocuments: Array<ProviderDocumentFragment>
}

export type AppendVerifiedProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<CreateProviderDocumentInput>
}>

export type AppendVerifiedProviderDocuments = {
  appendVerifiedProviderDocuments: Array<ProviderDocumentFragment>
}

export type UpdateVerifiedProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<UpdateProviderDocumentInput>
}>

export type UpdateVerifiedProviderDocuments = {
  updateVerifiedProviderDocuments: Array<ProviderDocumentFragment>
}

export type RemoveVerifiedProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']
  documentIds: Array<Scalars['ID']>
}>

export type RemoveVerifiedProviderDocuments = {
  removeVerifiedProviderDocuments: Array<ProviderDocumentFragment>
}

export type CreatePayerEnrollmentsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<CreatePayerEnrollmentInput>
}>

export type CreatePayerEnrollments = {
  createPayerEnrollments: Array<PayerEnrollmentFragment>
}

export type UpdatePayerEnrollmentsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<UpdatePayerEnrollmentInput>
}>

export type UpdatePayerEnrollments = {
  updatePayerEnrollments: Array<PayerEnrollmentFragment>
}

export type DeletePayerEnrollmentsVariables = Exact<{
  providerId: Scalars['ID']
  enrollmentIds: Array<Scalars['ID']>
}>

export type DeletePayerEnrollments = {
  deletePayerEnrollments: Array<PayerEnrollmentFragment>
}

export type CreatePayersVariables = Exact<{
  content: Array<PayerCreateInput>
}>

export type CreatePayers = { createPayers: Array<PayerFragment> }

export type UpdatePayersVariables = Exact<{
  content: Array<PayerUpdateInput>
}>

export type UpdatePayers = { updatePayers: Array<PayerFragment> }

export type DeletePayersVariables = Exact<{
  content: Array<Scalars['ID']>
}>

export type DeletePayers = { deletePayers: Array<PayerFragment> }

export type CreateProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProfessionalHistoryCreateInput>
}>

export type CreateProfessionalHistory = {
  createProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type UpdateProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProfessionalHistoryUpdateInput>
}>

export type UpdateProfessionalHistory = {
  updateProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type DeleteProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']
  ids: Array<Scalars['ID']>
}>

export type DeleteProfessionalHistory = {
  deleteProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type UpsertIdentifiersVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProviderIdentifierInput>
}>

export type UpsertIdentifiers = {
  upsertIdentifiers: Array<ProviderIdentifierFragment>
}

export type DeleteIdentifiersVariables = Exact<{
  providerId: Scalars['ID']
  identifierIds: Array<Scalars['ID']>
}>

export type DeleteIdentifiers = {
  deleteIdentifiers: Array<ProviderIdentifierFragment>
}

export type UpdateProviderCredentialingVariables = Exact<{
  providerId: Scalars['ID']
  content: ProviderCredentialingInput
}>

export type UpdateProviderCredentialing = {
  updateProviderCredentialing: ProviderCredentialingFragment
}

export type UpsertProviderExternalAccountsVariables = Exact<{
  providerId: Scalars['ID']
  content: Array<ProviderExternalAccountInput>
}>

export type UpsertProviderExternalAccounts = {
  upsertProviderExternalAccounts: Array<ProviderExternalAccountFragment>
}

export type DeleteProviderExternalAccountsVariables = Exact<{
  providerId: Scalars['ID']
  providerExternalAccountIds: Array<Scalars['ID']>
}>

export type DeleteProviderExternalAccounts = {
  deleteProviderExternalAccounts: Array<ProviderExternalAccountFragment>
}

export type BulkUpdateInsurancePlansVariables = Exact<{
  content: Array<BulkInsurancePlanUpdateInput>
}>

export type BulkUpdateInsurancePlans = {
  bulkUpdateInsurancePlans: Array<InsurancePlanFullFragment>
}

export type GetProvidersMinimalVariables = Exact<{ [key: string]: never }>

export type GetProvidersMinimal = {
  getProviders: Array<ProviderMinimalFragment>
}

export type GetProvidersVariables = Exact<{ [key: string]: never }>

export type GetProviders = { getProviders: Array<SearchProviderFragment> }

export type GetProvidersPagedVariables = Exact<{
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
}>

export type GetProvidersPaged = { getProviders: Array<SearchProviderFragment> }

export type GetProviderVariables = Exact<{
  id: Scalars['ID']
}>

export type GetProvider = { getProvider: ProviderFragment }

export type GetProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetProviderLicenseRequests = {
  getProvider: {
    _id: string
    licenseRequests?: Array<ProviderLicenseRequestFragment> | null
  }
}

export type GetProviderByCareManagerIdVariables = Exact<{
  id: Scalars['ID']
}>

export type GetProviderByCareManagerId = {
  getProviderByCareManagerId: ProviderFragment
}

export type GetEmploymentByProviderIdVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetEmploymentByProviderId = {
  getEmploymentByProviderId: EmploymentFragment
}

export type GetInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetInsurancePlans = {
  getInsurancePlans: Array<InsurancePlanFullFragment>
}

export type GetAllInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetAllInsurancePlans = {
  getInsurancePlans: Array<InsurancePlanFullFragment>
  getOutOfNetworkInsurancePlans: Array<InsurancePlanFullFragment>
}

export type GetInsuranceForVerificationVariables = Exact<{
  [key: string]: never
}>

export type GetInsuranceForVerification = {
  getInsurancePlans: Array<VerificationInsurancePlanFragment>
  getOutOfNetworkInsurancePlans: Array<
    { status: InsurancePlanStatus } & VerificationInsurancePlanFragment
  >
}

export type GetAllInsuranceMinimalVariables = Exact<{ [key: string]: never }>

export type GetAllInsuranceMinimal = {
  getInsurancePlans: Array<AllInsurancePlansMinimalFragment>
  getOutOfNetworkInsurancePlans: Array<AllInsurancePlansMinimalFragment>
}

export type GetActiveInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetActiveInsurancePlans = {
  getInsurancePlans: Array<SearchInsurancePlanFragment>
}

export type GetInheritingProvidersVariables = Exact<{
  providerId: Scalars['ID']
  insurancePlanIds: Array<Scalars['ID']>
}>

export type GetInheritingProviders = {
  getInheritingProviders: Array<{
    _id: string
    status?: ActiveStatus | null
    insurancePlan: FullInsurancePlanPartialFragment
    participatingProvider: PractMgrReferenceFragment
    billingRelationship: {
      type: BillingRelationshipType
      reference?: PractMgrReferenceFragment | null
    }
  }>
}

export type GetLocationsVariables = Exact<{ [key: string]: never }>

export type GetLocations = { getLocations: Array<LocationFragment> }

export type GetLocationsWhDetailsVariables = Exact<{ [key: string]: never }>

export type GetLocationsWhDetails = {
  getLocations: Array<{
    id: string
    name: string
    description?: string | null
    physicalType: CodeableConceptFragment
    address: AddressFragment
    identifiers?: Array<IdentifierFragment> | null
  }>
}

export type GetPmAggregatesVariables = Exact<{ [key: string]: never }>

export type GetPmAggregates = {
  getLocations: Array<LocationFragment>
  getInsurancePlans: Array<SearchInsurancePlanFragment>
}

export type GetProviderDocumentVariables = Exact<{
  providerId: Scalars['ID']
  documentId: Scalars['ID']
}>

export type GetProviderDocument = {
  getProviderDocument: ProviderDocumentFragment
}

export type GetProviderDocumentsByProviderIdVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetProviderDocumentsByProviderId = {
  getProviderDocumentsByProviderId: Array<ProviderDocumentFragment>
}

export type GetVerifiedProviderDocumentVariables = Exact<{
  providerId: Scalars['ID']
  documentId: Scalars['ID']
}>

export type GetVerifiedProviderDocument = {
  getVerifiedProviderDocument: ProviderDocumentFragment
}

export type GetVerifiedProviderDocumentsByProviderIdVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetVerifiedProviderDocumentsByProviderId = {
  getVerifiedProviderDocumentsByProviderId: Array<ProviderDocumentFragment>
}

export type GetPayerEnrollmentsByProviderIdVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetPayerEnrollmentsByProviderId = {
  getPayerEnrollmentsByProviderId: Array<PayerEnrollmentFragment>
}

export type GetPayersVariables = Exact<{ [key: string]: never }>

export type GetPayers = { getPayers: Array<PayerFragment> }

export type GetPayersSummaryVariables = Exact<{ [key: string]: never }>

export type GetPayersSummary = { getPayers: Array<PayerSummaryFrag> }

export type GetProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetProfessionalHistory = {
  getProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type GetProfessionalHistoryByIdVariables = Exact<{
  id: Scalars['ID']
}>

export type GetProfessionalHistoryById = {
  getProfessionalHistoryById: ProfessionalHistoryFragment
}

export type GetProviderCredentialingVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetProviderCredentialing = {
  getProviderCredentialing: ProviderCredentialingFragment
}

export type GetProviderExternalAccountsVariables = Exact<{
  providerId: Scalars['ID']
}>

export type GetProviderExternalAccounts = {
  getProviderExternalAccounts: Array<ProviderExternalAccountFragment>
}

export type GetPracticeStatesVariables = Exact<{ [key: string]: never }>

export type GetPracticeStates = {
  getPracticeStates: Array<PracticeStateFragment>
}

export type ReoccuranceTemplateSummaryFrag = {
  timezone: string
  planningHorizon: { startDate?: string | null; endDate?: string | null }
}

export type LocationSummaryFrag = {
  id: string
  name: string
  stateCode?: string | null
}

export type ScheduleSummaryFrag = {
  id: string
  active: boolean
  serviceCategory: { code: ServiceCategoryCode }
  reoccuranceTemplate: ReoccuranceTemplateSummaryFrag
  locations?: Array<LocationSummaryFrag> | null
}

export type SearchProviderMinimalFrag = {
  id: string
  careManagerId: string
  firstName: string
  lastName: string
  email: string
  employment?: {
    status?: EmploymentStatus | null
    profession?: ProfessionCode | null
  } | null
}

export type SearchProviderLicenseFrag = {
  id: string
  licenseType: LicenseType
  stateCode: string
  status: ActiveStatus
  number: string
  durationType?: LicenseDurationType | null
  issueDate?: string | null
  expirationDate?: string | null
  created: { date: string }
}

export type SearchProviderPayerEnrollmentFrag = {
  id: string
  careManagerId: string
  firstName: string
  lastName: string
  email: string
  employment?: {
    status?: EmploymentStatus | null
    stateOfResidence?: string | null
    profession?: ProfessionCode | null
    hireDate?: string | null
  } | null
  licenses?: Array<SearchProviderLicenseFrag> | null
  payerEnrollments?: Array<SearchPayerEnrollmentFrag> | null
  schedules?: Array<ScheduleSummaryFrag> | null
  identifiers?: Array<ProviderIdentifierFragment> | null
}

export type SearchPayerEnrollmentFrag = {
  id: string
  status: PayerEnrollmentStatus
  payer: { id: string; status: PayerStatus }
}

export type SearchProviderFrag = {
  id: string
  careManagerId: string
  firstName: string
  lastName: string
  email: string
  availability?: string | null
  availabilityNotes?: string | null
  genderIdentity?: GenderIdentity | null
  communityIdentity?: Array<CommunityIdentity> | null
  race?: Array<Race> | null
  ethnicity?: Ethnicity | null
  languages?: Array<string> | null
  spirituality?: Array<string> | null
  ages?: Array<string> | null
  modalities?: Array<string> | null
  specialties?: Array<string> | null
  bio?: string | null
  clinicalAges?: Array<string> | null
  clinicalModalities?: Array<string> | null
  clinicalSpecialties?: Array<string> | null
  serviceTypes?: Array<ProviderServiceType> | null
  employment?: EmploymentFragment | null
  identifiers?: Array<ProviderIdentifierFragment> | null
  supervisor?: PractMgrReferenceFragment | null
  careCoordinator?: PractMgrReferenceFragment | null
  supervisees?: Array<PractMgrReferenceFragment> | null
  teamLead?: PractMgrReferenceFragment | null
  expectedHours?: Array<ExpectedHoursFragment> | null
  licenses?: Array<{
    id: string
    licenseType: LicenseType
    stateCode: string
    status: ActiveStatus
    number: string
    issueDate?: string | null
    expirationDate?: string | null
    excludeFromPayerEnrollment: boolean
    created: { date: string }
  }> | null
  payerEnrollments?: Array<SearchPayerEnrollmentFrag> | null
  schedules?: Array<ScheduleSummaryFrag> | null
}

export type SearchProvidersVariables = Exact<{
  query: Scalars['AWSJSON']
  sort?: InputMaybe<Scalars['AWSJSON']>
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['Int']>
}>

export type SearchProviders = {
  searchProviders: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    results: Array<SearchProviderFrag>
  }
}

export type SearchPayerEnrollmentsVariables = Exact<{
  query: Scalars['AWSJSON']
  sort?: InputMaybe<Scalars['AWSJSON']>
  aggregations?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['Int']>
}>

export type SearchPayerEnrollments = {
  searchProviders: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    results: Array<SearchProviderPayerEnrollmentFrag>
  }
}

export type ProviderTypeAheadVariables = Exact<{
  query: Scalars['AWSJSON']
  sort?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
}>

export type ProviderTypeAhead = {
  searchProviders: {
    resultCount: number
    results: Array<SearchProviderMinimalFrag>
  }
}

export type GetProviderAggregatesVariables = Exact<{
  aggregations: Scalars['AWSJSON']
}>

export type GetProviderAggregates = {
  searchProviders: { aggregations?: string | null }
}

export type ReferenceFragment = {
  _id?: string | null
  type: ResourceType
  display?: string | null
}

export type AnnotationFragment = {
  time: string
  text: string
  authorReference: ReferenceFragment
}

export type ServiceCategoryFragment = { code: ServiceCategoryCode }

export type ServiceTypeFragment = { code: ServiceTypeCode }

export type ScheduleFragment = {
  _id: string
  active: boolean
  serviceCategory: ServiceCategoryFragment
  actors: Array<{
    _id?: string | null
    type: ResourceType
    display?: string | null
  }>
  reoccuranceTemplate: {
    timezone: string
    reoccuranceType: ReoccuranceType
    occuranceCount?: number | null
    planningHorizon: { startDate?: string | null; endDate?: string | null }
    weeklyTemplate?: Array<{
      offset: number
      interval: number
      dayTimes: Array<{
        startTime: string
        endTime: string
        dayOfWeek: DayOfWeek
      }>
    }> | null
  }
  notes?: Array<AnnotationFragment> | null
}

export type VirtualServiceFragment = {
  channelType: SessionType
  addressUrl?: string | null
  phoneNumber?: string | null
  sessionKey?: string | null
}

export type ReoccuranceTemplateFragment = {
  id: string
  timezone: string
  reoccuranceType: ReoccuranceType
  occuranceCount?: number | null
  lastOccuranceIndex?: number | null
  planningHorizon: { startDate?: string | null; endDate?: string | null }
  weeklyTemplate?: Array<{
    offset: number
    interval: number
    dayTimes: Array<{
      startTime: string
      endTime: string
      dayOfWeek: DayOfWeek
    }>
  }> | null
}

export type AppointmentFragment = {
  _id: string
  status: AppointmentStatus
  appointmentType: AppointmentType
  description?: string | null
  startDate: string
  endDate: string
  minutesDuration?: number | null
  occuranceChanged?: boolean | null
  occuranceIndex?: number | null
  cancelationReason?: string | null
  replacesAppointmentId?: string | null
  createdDate: string
  reoccuranceTemplate?: ReoccuranceTemplateFragment | null
  serviceCategory: ServiceCategoryFragment
  serviceType?: ServiceTypeFragment | null
  notes?: Array<AnnotationFragment> | null
  virtualService?: VirtualServiceFragment | null
  participants: Array<{
    required: boolean
    status?: ParticipationStatus | null
    actor: ReferenceFragment
    type?: { code: AppointmentParticipantTypeCode } | null
  }>
  identifiers?: Array<{
    source: AppointmentIdentifierSource
    value?: string | null
  }> | null
}

export type CreateAppointmentResponseFragment = {
  appointment: AppointmentFragment
  warnings: Array<AppointmentWarningFragment>
}

export type AppointmentWarningFragment = {
  startDate: string
  endDate: string
  message?: string | null
  code?: AppointmentWarningCode | null
}

export type UpdateReoccuranceTemplateResponseFragment = {
  reoccuranceTemplate: ReoccuranceTemplateFragment
  warnings: Array<AppointmentWarningFragment>
}

export type CreateScheduleVariables = Exact<{
  content: ScheduleInput
}>

export type CreateSchedule = { createSchedule: ScheduleFragment }

export type UpdateScheduleVariables = Exact<{
  id: Scalars['ID']
  content: ScheduleInput
}>

export type UpdateSchedule = { updateSchedule: ScheduleFragment }

export type DeleteScheduleVariables = Exact<{
  id: Scalars['ID']
}>

export type DeleteSchedule = { deleteSchedule: { _id: string } }

export type CreateAppointmentVariables = Exact<{
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}>

export type CreateAppointment = { createAppointment: AppointmentFragment }

export type UpdateAppointmentVariables = Exact<{
  id: Scalars['ID']
  content: UpdateAppointmentInput
  options?: InputMaybe<AppointmentOptions>
}>

export type UpdateAppointment = { updateAppointment: AppointmentFragment }

export type DeleteAppointmentVariables = Exact<{
  id: Scalars['ID']
}>

export type DeleteAppointment = { deleteAppointment: { _id: string } }

export type CreateAppointmentV2Variables = Exact<{
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}>

export type CreateAppointmentV2 = {
  createAppointmentV2: CreateAppointmentResponseFragment
}

export type UpdateReoccuranceTemplateVariables = Exact<{
  id: Scalars['ID']
  content: ReoccuranceTemplateInput
}>

export type UpdateReoccuranceTemplate = {
  updateReoccuranceTemplate: UpdateReoccuranceTemplateResponseFragment
}

export type GetScheduleVariables = Exact<{
  _id: Scalars['ID']
}>

export type GetSchedule = { getSchedule?: ScheduleFragment | null }

export type SearchSchedulesVariables = Exact<{
  content?: InputMaybe<Array<SearchFilter>>
  sort?: InputMaybe<Array<SortParam>>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
}>

export type SearchSchedules = {
  searchSchedules?: {
    searchAfter?: string | null
    results: Array<ScheduleFragment>
  } | null
}

export type GetSchedulesByProviderIdVariables = Exact<{
  id: Scalars['String']
}>

export type GetSchedulesByProviderId = {
  searchSchedules?: { results: Array<ScheduleFragment> } | null
}

export type GetAppointmentVariables = Exact<{
  id: Scalars['ID']
}>

export type GetAppointment = { getAppointment?: AppointmentFragment | null }

export type SearchAppointmentsVariables = Exact<{
  content?: InputMaybe<Array<SearchFilter>>
  sort?: InputMaybe<Array<SortParam>>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
}>

export type SearchAppointments = {
  searchAppointments?: {
    searchAfter?: string | null
    results: Array<AppointmentFragment>
  } | null
}

export type GetPatientAppointmentsByDateRangeVariables = Exact<{
  treatmentId: Scalars['String']
  from: Scalars['String']
  to: Scalars['String']
  pageSize?: InputMaybe<Scalars['Int']>
}>

export type GetPatientAppointmentsByDateRange = {
  searchAppointments?: {
    searchAfter?: string | null
    results: Array<AppointmentFragment>
  } | null
}

export type GetAppointmentsByProviderIdVariables = Exact<{
  id: Scalars['String']
}>

export type GetAppointmentsByProviderId = {
  searchAppointments?: { results: Array<AppointmentFragment> } | null
}

export type GetNextLastApptByTreatmentIdVariables = Exact<{
  id: Scalars['String']
  now: Scalars['String']
}>

export type GetNextLastApptByTreatmentId = {
  getNextApptByPatientId?: {
    results: Array<{
      _id: string
      startDate: string
      endDate: string
      status: AppointmentStatus
      serviceCategory: { code: ServiceCategoryCode }
      serviceType?: { code: ServiceTypeCode } | null
    }>
  } | null
  getLastApptByPatientId?: {
    results: Array<{
      _id: string
      startDate: string
      endDate: string
      status: AppointmentStatus
      serviceCategory: { code: ServiceCategoryCode }
      serviceType?: { code: ServiceTypeCode } | null
    }>
  } | null
}

export type TaskReferenceFragment = {
  _id?: string | null
  type: ResourceType
  display?: string | null
  reference?: string | null
  active?: boolean | null
}

export type SearchableReferenceFragment = {
  id?: string | null
  display?: string | null
  reference?: string | null
  active?: boolean | null
}

export type TaskAnnotationFragment = {
  time: string
  text: string
  authorReference: TaskReferenceFragment
}

export type TaskFragment = {
  _id: string
  type: TaskType
  status: TaskStatus
  patientId: string
  patientPreferences?: string | null
  treatmentId: string
  description: string
  dueDate: string
  referralSource?: string | null
  serviceType?: TaskServiceType | null
  createdDate: string
  lastUpdatedDate: string
  patient?: {
    id?: string | null
    display?: string | null
    mrn?: string | null
  } | null
  comments?: Array<TaskAnnotationFragment> | null
  assignee: TaskReferenceFragment
  createdBy: TaskReferenceFragment
}

export type SearchableTaskFragment = {
  id: string
  type: TaskType
  status: TaskStatus
  treatmentId: string
  description: string
  dueDate: string
  referralSource?: string | null
  serviceType?: TaskServiceType | null
  createdDate: string
  lastUpdatedDate: string
  patient?: {
    id?: string | null
    display?: string | null
    mrn?: string | null
  } | null
  assignee: SearchableReferenceFragment
  createdBy: SearchableReferenceFragment
  recentComments: Array<{ text: string; time: string }>
}

export type CreateTaskVariables = Exact<{
  content: CreateTaskInput
}>

export type CreateTask = { createTask: TaskFragment }

export type UpdateTaskVariables = Exact<{
  content: UpdateTaskInputV2
}>

export type UpdateTask = { updateTaskV2: TaskFragment }

export type UpdateTasksVariables = Exact<{
  content: Array<UpdateTaskInputV2>
}>

export type UpdateTasks = { updateTasks: Array<TaskFragment> }

export type DeleteTaskVariables = Exact<{
  _id: Scalars['ID']
}>

export type DeleteTask = { deleteTask: TaskFragment }

export type GetTasksByTreatmentIdVariables = Exact<{
  treatmentId: Scalars['ID']
}>

export type GetTasksByTreatmentId = {
  getTasksByTreatmentIds: Array<TaskFragment>
}

export type GetTasksVariables = Exact<{ [key: string]: never }>

export type GetTasks = { getTasks: Array<TaskFragment> }

export type GetTaskVariables = Exact<{
  _id: Scalars['ID']
}>

export type GetTask = { getTask: TaskFragment }

export type SearchTasksVariables = Exact<{
  query: Scalars['AWSJSON']
  sort?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['Int']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']>
  aggregations?: InputMaybe<Scalars['AWSJSON']>
}>

export type SearchTasks = {
  searchTasks: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    tasks: Array<SearchableTaskFragment>
  }
}

export type GetSearchTasksAggregatesVariables = Exact<{
  query: Scalars['AWSJSON']
  aggregations: Scalars['AWSJSON']
}>

export type GetSearchTasksAggregates = {
  searchTasks: { aggregations?: string | null }
}

export type CareManagerFragment = {
  id: string
  careManagerId: string
  emrId?: string | null
  username: string
  firstName: string
  lastName: string
  email: string
  pronouns?: string | null
  isProvider: boolean
  isEnabled: boolean
  permissions?: {
    isSupervisor?: boolean | null
    addPatients?: boolean | null
    viewAllPatients?: boolean | null
    isAdmin?: boolean | null
    caseloadBulkSend?: boolean | null
    accessToNotes?: boolean | null
  } | null
}

export type CareManagerSearchFragment = {
  id: string
  careManagerId: string
  emrId?: string | null
  username: string
  email: string
  firstName: string
  lastName: string
  isEnabled: boolean
  isProvider: boolean
}

export type CognitoFragment = {
  userStatus: string
  isEnabled: boolean
  userAttributes: {
    sub: string
    given_name?: string | null
    family_name?: string | null
    email: string
    picture?: string | null
    pronouns?: string | null
    nickname?: string | null
    phone_number?: string | null
  }
}

export type CognitoSearchFragment = {
  userStatus: string
  isEnabled: boolean
  userAttributes: {
    sub: string
    given_name?: string | null
    family_name?: string | null
    email: string
    picture?: string | null
    nickname?: string | null
  }
}

export type UserSearchFragment = {
  permitRoles?: Array<string> | null
  careManager: CareManagerSearchFragment
  cognito?: CognitoSearchFragment | null
}

export type UserFullFragment = {
  permitRoles?: Array<string> | null
  careManager: CareManagerFragment
  cognito?: CognitoFragment | null
}

export type UserProvisionedFullFragment = {
  permitRoles?: Array<string> | null
  careManager: CareManagerFragment
  cognito: CognitoFragment
}

export type UsrNamesFragment = { expandedName?: string | null }

export type UsrSummaryFragment = {
  careManagerId?: string | null
  providerId?: string | null
  cognitoUserId?: string | null
  display: UsrNamesFragment
}

export type UserSignUpWithGoogleVariables = Exact<{
  content: GoogleSignUpInput
}>

export type UserSignUpWithGoogle = {
  signUpGoogleUser: UserProvisionedFullFragment
}

export type UserSignUpVariables = Exact<{
  content: UserSignUpInput
}>

export type UserSignUp = { signUpUser: UserProvisionedFullFragment }

export type UpdateUserVariables = Exact<{
  cognitoUserId: Scalars['ID']
  content: UserUpdateInput
}>

export type UpdateUser = { updateUser: UserProvisionedFullFragment }

export type RevokeUserVariables = Exact<{
  id: Scalars['String']
}>

export type RevokeUser = {
  revokeUser: {
    careManager: { id: string }
    cognito?: { userStatus: string } | null
  }
}

export type RemoveUserVariables = Exact<{
  id: Scalars['String']
}>

export type RemoveUser = { removeUser: { careManager: { id: string } } }

export type RestoreUserVariables = Exact<{
  id: Scalars['String']
}>

export type RestoreUser = {
  restoreUser: { careManager: { id: string }; cognito: { userStatus: string } }
}

export type ResendUserPasswordVariables = Exact<{
  cognitoUserId: Scalars['ID']
}>

export type ResendUserPassword = { resendUserPassword: { isSuccess: boolean } }

export type GetAllUsersVariables = Exact<{ [key: string]: never }>

export type GetAllUsers = { getUsers?: Array<UserSearchFragment> | null }

export type GetUserVariables = Exact<{
  email: Scalars['String']
}>

export type GetUser = { getUser: UserFullFragment }

export type GetUserByCareManagerIdVariables = Exact<{
  id: Scalars['ID']
}>

export type GetUserByCareManagerId = { getUserById: UserFullFragment }

export type GetUserByCognitoUserIdVariables = Exact<{
  id: Scalars['ID']
}>

export type GetUserByCognitoUserId = { getUserById: UserFullFragment }

export type GetSecurityRolesVariables = Exact<{ [key: string]: never }>

export type GetSecurityRoles = {
  listSecurityRoles: Array<{ name: string; key: string }>
}

export type DescribeUsersByCareManagerIdVariables = Exact<{
  ids: Array<Scalars['String']>
}>

export type DescribeUsersByCareManagerId = {
  describeUsersByCareManagerId: Array<UsrSummaryFragment>
}

export type DescribeUsersByProviderIdVariables = Exact<{
  ids: Array<Scalars['String']>
}>

export type DescribeUsersByProviderId = {
  describeUsersByProviderId: Array<UsrSummaryFragment>
}

export type DescribeUsersByCognitoIdVariables = Exact<{
  ids: Array<Scalars['String']>
}>

export type DescribeUsersByCognitoId = {
  describeUsersByCognitoUserId: Array<UsrSummaryFragment>
}

export type EncryptResponseFragment = { cipherText: string; algorithm: string }

export type DecryptResponseFragment = { plainText: string }

export type EncryptVariables = Exact<{
  input: EncryptInput
}>

export type Encrypt = { encrypt: EncryptResponseFragment }

export type DecryptVariables = Exact<{
  input: DecryptInput
}>

export type Decrypt = { decrypt: DecryptResponseFragment }
